/* tslint:disable */
/* eslint-disable */
/**
 * 
 * @export
 * @interface AccountChangeAddressModel
 */
export interface AccountChangeAddressModel {
    /**
     * Post code specific to the selected country
     * @type {string}
     * @memberof AccountChangeAddressModel
     */
    zip_code: string;
    /**
     * Country of user
     * @type {string}
     * @memberof AccountChangeAddressModel
     */
    country?: AccountChangeAddressModelCountryEnum;
}

/**
* @export
* @enum {string}
*/
export enum AccountChangeAddressModelCountryEnum {
    EnGb = 'en_GB',
    DeDe = 'de_DE',
    SvSe = 'sv_SE',
    ItIt = 'it_IT',
    PlPl = 'pl_PL',
    HuHu = 'hu_HU',
    CsCz = 'cs_CZ',
    HrHr = 'hr_HR',
    EnUk = 'en_UK',
    NlNl = 'nl_NL'
}

/**
 * 
 * @export
 * @interface AccountChangeEmailModel
 */
export interface AccountChangeEmailModel {
    /**
     * 
     * @type {string}
     * @memberof AccountChangeEmailModel
     */
    email: string;
}
/**
 * 
 * @export
 * @interface AccountGetAccountUsersByIdsUserIdsParameterInner
 */
export interface AccountGetAccountUsersByIdsUserIdsParameterInner {
}
/**
 * 
 * @export
 * @interface AccountOrderRequestQuery
 */
export interface AccountOrderRequestQuery {
    /**
     * 
     * @type {string}
     * @memberof AccountOrderRequestQuery
     */
    by: AccountOrderRequestQueryByEnum;
    /**
     * 
     * @type {string}
     * @memberof AccountOrderRequestQuery
     */
    direction: AccountOrderRequestQueryDirectionEnum;
}

/**
* @export
* @enum {string}
*/
export enum AccountOrderRequestQueryByEnum {
    Name = 'name',
    CreatedOn = 'created_on',
    Role = 'role'
}
/**
* @export
* @enum {string}
*/
export enum AccountOrderRequestQueryDirectionEnum {
    Asc = 'ASC',
    Desc = 'DESC',
}

/**
 * 
 * @export
 * @interface AccountUserAddModel
 */
export interface AccountUserAddModel {
    /**
     * 
     * @type {string}
     * @memberof AccountUserAddModel
     */
    username?: string;
    /**
     * 
     * @type {NameModel}
     * @memberof AccountUserAddModel
     */
    name: NameModel;
    /**
     * 
     * @type {string}
     * @memberof AccountUserAddModel
     */
    country: AccountUserAddModelCountryEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccountUserAddModel
     */
    roles: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AccountUserAddModel
     */
    installerCompanyId?: string;
}

/**
* @export
* @enum {string}
*/
export enum AccountUserAddModelCountryEnum {
    EnGb = 'en_GB',
    DeDe = 'de_DE',
    SvSe = 'sv_SE',
    ItIt = 'it_IT',
    PlPl = 'pl_PL',
    HuHu = 'hu_HU',
    CsCz = 'cs_CZ',
    HrHr = 'hr_HR',
    EnUk = 'en_UK',
    NlNl = 'nl_NL'
}

/**
 * 
 * @export
 * @interface AccountUserModifyModel
 */
export interface AccountUserModifyModel {
    /**
     * 
     * @type {string}
     * @memberof AccountUserModifyModel
     */
    country?: AccountUserModifyModelCountryEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccountUserModifyModel
     */
    roles?: Array<string>;
    /**
     * 
     * @type {NameModel}
     * @memberof AccountUserModifyModel
     */
    name?: NameModel;
    /**
     * 
     * @type {string}
     * @memberof AccountUserModifyModel
     */
    language?: string;
}

/**
* @export
* @enum {string}
*/
export enum AccountUserModifyModelCountryEnum {
    EnGb = 'en_GB',
    DeDe = 'de_DE',
    SvSe = 'sv_SE',
    ItIt = 'it_IT',
    PlPl = 'pl_PL',
    HuHu = 'hu_HU',
    CsCz = 'cs_CZ',
    HrHr = 'hr_HR',
    EnUk = 'en_UK',
    NlNl = 'nl_NL'
}

/**
 * 
 * @export
 * @interface AccountUserResponseModel
 */
export interface AccountUserResponseModel {
    /**
     * 
     * @type {string}
     * @memberof AccountUserResponseModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountUserResponseModel
     */
    idp_provider?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountUserResponseModel
     */
    username?: string;
    /**
     * 
     * @type {NameModel}
     * @memberof AccountUserResponseModel
     */
    name?: NameModel;
    /**
     * 
     * @type {string}
     * @memberof AccountUserResponseModel
     */
    language?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountUserResponseModel
     */
    invite_link?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccountUserResponseModel
     */
    roles?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AccountUserResponseModel
     */
    isYou?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AccountUserResponseModel
     */
    created_on?: string;
}
/**
 * 
 * @export
 * @interface AccountUsersResponseModel
 */
export interface AccountUsersResponseModel {
    /**
     * 
     * @type {number}
     * @memberof AccountUsersResponseModel
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof AccountUsersResponseModel
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof AccountUsersResponseModel
     */
    limit: number;
    /**
     * 
     * @type {Array<AccountUserResponseModel>}
     * @memberof AccountUsersResponseModel
     */
    list: Array<AccountUserResponseModel>;
}
/**
 * 
 * @export
 * @interface ActivityLogFilter
 */
export interface ActivityLogFilter {
    /**
     * 
     * @type {string}
     * @memberof ActivityLogFilter
     */
    ownerId?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogFilter
     */
    actionType?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogFilter
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogFilter
     */
    timestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogFilter
     */
    objectSource?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogFilter
     */
    source: ActivityLogFilterSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogFilter
     */
    applicationId?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogFilter
     */
    ownerCustomerId?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogFilter
     */
    moderatorCustomerId?: string;
}

/**
* @export
* @enum {string}
*/
export enum ActivityLogFilterSourceEnum {
    Event = 'event',
    Database = 'database',
    CustomerImport = 'customer-import'
}

/**
 * 
 * @export
 * @interface ActivityLogResponseModel
 */
export interface ActivityLogResponseModel {
    /**
     * 
     * @type {string}
     * @memberof ActivityLogResponseModel
     */
    moderatorUserId?: string;
    /**
     * 
     * @type {ActivityModeratorModel}
     * @memberof ActivityLogResponseModel
     */
    moderator?: ActivityModeratorModel;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogResponseModel
     */
    application?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogResponseModel
     */
    actionType?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogResponseModel
     */
    objectSource?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogResponseModel
     */
    ownerId?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogResponseModel
     */
    previousState?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogResponseModel
     */
    currentState?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogResponseModel
     */
    operationDetails?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogResponseModel
     */
    operationStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogResponseModel
     */
    customerEmail?: string;
    /**
     * 
     * @type {number}
     * @memberof ActivityLogResponseModel
     */
    creationTime?: number;
}
/**
 * 
 * @export
 * @interface ActivityModeratorModel
 */
export interface ActivityModeratorModel {
    /**
     * 
     * @type {string}
     * @memberof ActivityModeratorModel
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityModeratorModel
     */
    tenant?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityModeratorModel
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface AdminUserRequestPreferencesModel
 */
export interface AdminUserRequestPreferencesModel {
    /**
     * 
     * @type {PreferencesModel}
     * @memberof AdminUserRequestPreferencesModel
     */
    preferences?: PreferencesModel;
}
/**
 * 
 * @export
 * @interface AdminUserResponsePreferencesModel
 */
export interface AdminUserResponsePreferencesModel {
    /**
     * 
     * @type {PreferencesModel}
     * @memberof AdminUserResponsePreferencesModel
     */
    preferences?: PreferencesModel;
    /**
     * 
     * @type {string}
     * @memberof AdminUserResponsePreferencesModel
     */
    userId?: string;
}
/**
 * 
 * @export
 * @interface ApplicationModel
 */
export interface ApplicationModel {
    /**
     * 
     * @type {string}
     * @memberof ApplicationModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationModel
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface AssignInstallersToCompanyRequestModel
 */
export interface AssignInstallersToCompanyRequestModel {
    /**
     * 
     * @type {Set<string>}
     * @memberof AssignInstallersToCompanyRequestModel
     */
    installersIds: Set<string>;
}
/**
 * 
 * @export
 * @interface AssignToCustomerRequestBody
 */
export interface AssignToCustomerRequestBody {
    /**
     * 
     * @type {AssignToCustomerRequestBodyCustomer}
     * @memberof AssignToCustomerRequestBody
     */
    customer?: AssignToCustomerRequestBodyCustomer;
}
/**
 * @type AssignToCustomerRequestBodyCustomer
 * 
 * @export
 */
export type AssignToCustomerRequestBodyCustomer = string;
/**
 * 
 * @export
 * @interface AssignToCustomerThroughPartnerRequestBody
 */
export interface AssignToCustomerThroughPartnerRequestBody {
    /**
     * 
     * @type {string}
     * @memberof AssignToCustomerThroughPartnerRequestBody
     */
    customer_id: string;
    /**
     * 
     * @type {string}
     * @memberof AssignToCustomerThroughPartnerRequestBody
     */
    gridbox_start_code: string;
}
/**
 * 
 * @export
 * @interface AssignedCustomer
 */
export interface AssignedCustomer {
    /**
     * 
     * @type {string}
     * @memberof AssignedCustomer
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignedCustomer
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignedCustomer
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignedCustomer
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignedCustomer
     */
    zip_code?: string;
}
/**
 * 
 * @export
 * @interface AssignedDeviceResponseModel
 */
export interface AssignedDeviceResponseModel {
    /**
     * 
     * @type {string}
     * @memberof AssignedDeviceResponseModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignedDeviceResponseModel
     */
    deviceType?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignedDeviceResponseModel
     */
    deviceId?: string;
    /**
     * 
     * @type {UnallocatedDeviceResponseModelDeviceConfiguration}
     * @memberof AssignedDeviceResponseModel
     */
    deviceConfiguration?: UnallocatedDeviceResponseModelDeviceConfiguration;
    /**
     * 
     * @type {DeviceGateway}
     * @memberof AssignedDeviceResponseModel
     */
    deviceGateway?: DeviceGateway;
    /**
     * 
     * @type {string}
     * @memberof AssignedDeviceResponseModel
     */
    vendorName?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignedDeviceResponseModel
     */
    timezone?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignedDeviceResponseModel
     */
    creationTime?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignedDeviceResponseModel
     */
    modifiedTime?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignedDeviceResponseModel
     */
    siteId?: string;
}
/**
 * 
 * @export
 * @interface AssignedInstallation
 */
export interface AssignedInstallation {
    /**
     * 
     * @type {string}
     * @memberof AssignedInstallation
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignedInstallation
     */
    deviceType?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignedInstallation
     */
    deviceId?: string;
    /**
     * 
     * @type {GatewayDeviceConfiguration}
     * @memberof AssignedInstallation
     */
    deviceConfiguration?: GatewayDeviceConfiguration;
    /**
     * 
     * @type {DeviceGateway}
     * @memberof AssignedInstallation
     */
    deviceGateway?: DeviceGateway;
    /**
     * 
     * @type {string}
     * @memberof AssignedInstallation
     */
    vendorName?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignedInstallation
     */
    vendorId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignedInstallation
     */
    siteId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignedInstallation
     */
    creationTime?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignedInstallation
     */
    modifiedTime?: string;
    /**
     * 
     * @type {AssignedCustomer}
     * @memberof AssignedInstallation
     */
    customer?: AssignedCustomer;
}
/**
 * 
 * @export
 * @interface AssignedInstallationsResponseModel
 */
export interface AssignedInstallationsResponseModel {
    /**
     * 
     * @type {number}
     * @memberof AssignedInstallationsResponseModel
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof AssignedInstallationsResponseModel
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof AssignedInstallationsResponseModel
     */
    limit: number;
    /**
     * 
     * @type {Array<AssignedInstallation>}
     * @memberof AssignedInstallationsResponseModel
     */
    list: Array<AssignedInstallation>;
}
/**
 * 
 * @export
 * @interface Auth0ContextSettings
 */
export interface Auth0ContextSettings {
    /**
     * 
     * @type {string}
     * @memberof Auth0ContextSettings
     */
    domain: string;
    /**
     * 
     * @type {string}
     * @memberof Auth0ContextSettings
     */
    client_id: string;
    /**
     * 
     * @type {string}
     * @memberof Auth0ContextSettings
     */
    secret_id: string;
}
/**
 * 
 * @export
 * @interface AuthenticationRequestModel
 */
export interface AuthenticationRequestModel {
    /**
     * 
     * @type {string}
     * @memberof AuthenticationRequestModel
     */
    token?: string;
}
/**
 * 
 * @export
 * @interface AuthenticationResponseModel
 */
export interface AuthenticationResponseModel {
    /**
     * 
     * @type {string}
     * @memberof AuthenticationResponseModel
     */
    access_token?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationResponseModel
     */
    refresh_token?: string;
    /**
     * 
     * @type {number}
     * @memberof AuthenticationResponseModel
     */
    expires_in?: number;
    /**
     * 
     * @type {Array<AuthorizationResponseModel>}
     * @memberof AuthenticationResponseModel
     */
    scopes?: Array<AuthorizationResponseModel>;
    /**
     * 
     * @type {boolean}
     * @memberof AuthenticationResponseModel
     */
    multiFactorAuthentication?: boolean;
}
/**
 * 
 * @export
 * @interface AuthorizationResponseModel
 */
export interface AuthorizationResponseModel {
    /**
     * 
     * @type {string}
     * @memberof AuthorizationResponseModel
     */
    action?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthorizationResponseModel
     */
    resource?: string;
}
/**
 * 
 * @export
 * @interface BadRequest
 */
export interface BadRequest {
    /**
     * The error name
     * @type {string}
     * @memberof BadRequest
     */
    name: string;
    /**
     * An error message
     * @type {string}
     * @memberof BadRequest
     */
    message: string;
    /**
     * The status code of the exception
     * @type {number}
     * @memberof BadRequest
     */
    status: number;
    /**
     * A list of related errors
     * @type {Array<GenericError>}
     * @memberof BadRequest
     */
    errors?: Array<GenericError>;
    /**
     * The stack trace (only in development mode)
     * @type {string}
     * @memberof BadRequest
     */
    stack?: string;
}
/**
 * 
 * @export
 * @interface BatteryModel
 */
export interface BatteryModel {
    /**
     * 
     * @type {boolean}
     * @memberof BatteryModel
     */
    installed?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BatteryModel
     */
    capacity?: number;
    /**
     * 
     * @type {string}
     * @memberof BatteryModel
     */
    manufacturer?: string;
    /**
     * 
     * @type {string}
     * @memberof BatteryModel
     */
    model?: string;
    /**
     * 
     * @type {string}
     * @memberof BatteryModel
     */
    firmware?: string;
    /**
     * 
     * @type {number}
     * @memberof BatteryModel
     */
    maxPower?: number;
    /**
     * 
     * @type {string}
     * @memberof BatteryModel
     */
    serialnumber?: string;
}
/**
 * 
 * @export
 * @interface BusinessReportDataResponseModel
 */
export interface BusinessReportDataResponseModel {
    /**
     * 
     * @type {object}
     * @memberof BusinessReportDataResponseModel
     */
    total?: object;
    /**
     * 
     * @type {string}
     * @memberof BusinessReportDataResponseModel
     */
    aggregation?: BusinessReportDataResponseModelAggregationEnum;
    /**
     * 
     * @type {Array}
     * @memberof BusinessReportDataResponseModel
     */
    range?: Array<any>;
}

/**
* @export
* @enum {string}
*/
export enum BusinessReportDataResponseModelAggregationEnum {
    Day = 'day',
    Week = 'week',
    Month = 'month',
    Year = 'year'
}

/**
 * 
 * @export
 * @interface CiamContextSettings
 */
export interface CiamContextSettings {
    /**
     * 
     * @type {string}
     * @memberof CiamContextSettings
     */
    dashboardAppId: string;
}
/**
 * 
 * @export
 * @interface CmsConsentCurrent
 */
export interface CmsConsentCurrent {
    /**
     * 
     * @type {string}
     * @memberof CmsConsentCurrent
     */
    name: CmsConsentCurrentNameEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CmsConsentCurrent
     */
    opting: boolean;
}

/**
* @export
* @enum {string}
*/
export enum CmsConsentCurrentNameEnum {
    TermsOfUse = 'TermsOfUse',
    RemoteSupportAndManufacturer = 'RemoteSupportAndManufacturer',
    RemoteInstaller = 'RemoteInstaller'
}

/**
 * 
 * @export
 * @interface CmsConsentHistoryLanguage
 */
export interface CmsConsentHistoryLanguage {
    /**
     * 
     * @type {HistoryConsent}
     * @memberof CmsConsentHistoryLanguage
     */
    de?: HistoryConsent;
    /**
     * 
     * @type {HistoryConsent}
     * @memberof CmsConsentHistoryLanguage
     */
    sv?: HistoryConsent;
    /**
     * 
     * @type {HistoryConsent}
     * @memberof CmsConsentHistoryLanguage
     */
    en?: HistoryConsent;
    /**
     * 
     * @type {HistoryConsent}
     * @memberof CmsConsentHistoryLanguage
     */
    it?: HistoryConsent;
    /**
     * 
     * @type {HistoryConsent}
     * @memberof CmsConsentHistoryLanguage
     */
    ro?: HistoryConsent;
}
/**
 * 
 * @export
 * @interface CmsCustomerModel
 */
export interface CmsCustomerModel {
    /**
     * 
     * @type {string}
     * @memberof CmsCustomerModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CmsCustomerModel
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CmsCustomerModel
     */
    parentId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CmsCustomerModel
     */
    isSelfOrDescendant?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CmsCustomerModel
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof CmsCustomerModel
     */
    customerType?: string;
    /**
     * 
     * @type {Array}
     * @memberof CmsCustomerModel
     */
    supportedLanguages?: Array<any>;
    /**
     * 
     * @type {Array}
     * @memberof CmsCustomerModel
     */
    children?: Array<any>;
}
/**
 * 
 * @export
 * @interface CmsImageUploadResponseModel
 */
export interface CmsImageUploadResponseModel {
    /**
     * 
     * @type {string}
     * @memberof CmsImageUploadResponseModel
     */
    location?: string;
}
/**
 * 
 * @export
 * @interface CognitoContextSettings
 */
export interface CognitoContextSettings {
    /**
     * 
     * @type {string}
     * @memberof CognitoContextSettings
     */
    pool_id: string;
    /**
     * 
     * @type {string}
     * @memberof CognitoContextSettings
     */
    client_id: string;
}
/**
 * 
 * @export
 * @interface ComparableModel
 */
export interface ComparableModel {
    /**
     * The comparable data from timescale db as raw data value
     * @type {object}
     * @memberof ComparableModel
     */
    timescaleData?: object;
    /**
     * The data for the given siteId from the data-import-webhook
     * @type {object}
     * @memberof ComparableModel
     */
    webhookData?: object;
}
/**
 * 
 * @export
 * @interface ConfigurationClientAccess
 */
export interface ConfigurationClientAccess {
    /**
     * 
     * @type {string}
     * @memberof ConfigurationClientAccess
     */
    vendorTokenId: string;
}
/**
 * 
 * @export
 * @interface Conflict
 */
export interface Conflict {
    /**
     * The error name
     * @type {string}
     * @memberof Conflict
     */
    name: string;
    /**
     * An error message
     * @type {string}
     * @memberof Conflict
     */
    message: string;
    /**
     * The status code of the exception
     * @type {number}
     * @memberof Conflict
     */
    status: number;
    /**
     * A list of related errors
     * @type {Array<GenericError>}
     * @memberof Conflict
     */
    errors?: Array<GenericError>;
    /**
     * The stack trace (only in development mode)
     * @type {string}
     * @memberof Conflict
     */
    stack?: string;
}
/**
 * 
 * @export
 * @interface Consent
 */
export interface Consent {
    /**
     * 
     * @type {Array<CmsConsentCurrent>}
     * @memberof Consent
     */
    current?: Array<CmsConsentCurrent>;
    /**
     * 
     * @type {Array<CmsConsentHistoryLanguage>}
     * @memberof Consent
     */
    history?: Array<CmsConsentHistoryLanguage>;
    /**
     * 
     * @type {Array<InternalConsent>}
     * @memberof Consent
     */
    consents?: Array<InternalConsent>;
}
/**
 * 
 * @export
 * @interface ContainsFieldType
 */
export interface ContainsFieldType {
    /**
     * 
     * @type {string}
     * @memberof ContainsFieldType
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface Content
 */
export interface Content {
    /**
     * 
     * @type {string}
     * @memberof Content
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Content
     */
    tenantId: string;
    /**
     * 
     * @type {string}
     * @memberof Content
     */
    state: ContentStateEnum;
    /**
     * 
     * @type {string}
     * @memberof Content
     */
    schemaName: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Content
     */
    fields: { [key: string]: any; };
    /**
     * 
     * @type {Metadata}
     * @memberof Content
     */
    meta: Metadata;
    /**
     * 
     * @type {number}
     * @memberof Content
     */
    order?: number;
}

/**
* @export
* @enum {string}
*/
export enum ContentStateEnum {
    Draft = 'draft',
    Published = 'published',
    Freeze = 'freeze'
}

/**
 * 
 * @export
 * @interface ContentFields
 */
export interface ContentFields {
    [key: string]: any | any;
    /**
     * 
     * @type {string}
     * @memberof ContentFields
     */
    title?: string;
}
/**
 * @type ContentManagmentSystemV3ReadMediaInfo200Response
 * 
 * @export
 */
export type ContentManagmentSystemV3ReadMediaInfo200Response = MediaInfo | { [key: string]: MediaInfoResponseMappingsValue; };
/**
 * 
 * @export
 * @interface CreateContentRequest
 */
export interface CreateContentRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateContentRequest
     */
    state?: CreateContentRequestStateEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateContentRequest
     */
    order?: number;
    /**
     * 
     * @type {ContentFields}
     * @memberof CreateContentRequest
     */
    fields?: ContentFields;
}

/**
* @export
* @enum {string}
*/
export enum CreateContentRequestStateEnum {
    Draft = 'draft',
    Published = 'published',
    Freeze = 'freeze'
}

/**
 * 
 * @export
 * @interface CreatedByModel
 */
export interface CreatedByModel {
    /**
     * 
     * @type {string}
     * @memberof CreatedByModel
     */
    tenant?: string;
    /**
     * Member name if the same customer 
     * @type {string}
     * @memberof CreatedByModel
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface CreatedCustomerResponseModel
 */
export interface CreatedCustomerResponseModel {
    /**
     * 
     * @type {string}
     * @memberof CreatedCustomerResponseModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatedCustomerResponseModel
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatedCustomerResponseModel
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatedCustomerResponseModel
     */
    customer_type?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatedCustomerResponseModel
     */
    created_on?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatedCustomerResponseModel
     */
    deleted_by?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatedCustomerResponseModel
     */
    modified_on?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatedCustomerResponseModel
     */
    idp_status?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatedCustomerResponseModel
     */
    ext_reference?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatedCustomerResponseModel
     */
    ext_reference_1?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatedCustomerResponseModel
     */
    ext_source?: string;
}
/**
 * 
 * @export
 * @interface CustomerAddFeatureGroupModel
 */
export interface CustomerAddFeatureGroupModel {
    /**
     * 
     * @type {string}
     * @memberof CustomerAddFeatureGroupModel
     */
    feature_group_id: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAddFeatureGroupModel
     */
    ext_reference_1?: string;
}
/**
 * 
 * @export
 * @interface CustomerAddModel
 */
export interface CustomerAddModel {
    /**
     * 
     * @type {string}
     * @memberof CustomerAddModel
     */
    customer_type: CustomerAddModelCustomerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CustomerAddModel
     */
    account_name: string;
    /**
     * 
     * @type {NameModel}
     * @memberof CustomerAddModel
     */
    name: NameModel;
    /**
     * 
     * @type {string}
     * @memberof CustomerAddModel
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAddModel
     */
    site_name?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAddModel
     */
    country: CustomerAddModelCountryEnum;
    /**
     * 
     * @type {string}
     * @memberof CustomerAddModel
     */
    city?: string;
    /**
     * Optional. Otherwise taken from the country language
     * @type {string}
     * @memberof CustomerAddModel
     */
    language?: CustomerAddModelLanguageEnum;
    /**
     * Post code specific to the selected country
     * @type {string}
     * @memberof CustomerAddModel
     */
    zip_code?: string;
    /**
     * Optional. Otherwise is sub-account of the root account
     * @type {string}
     * @memberof CustomerAddModel
     */
    tenant_id?: string;
    /**
     * Optional. Otherwise basic subscription is taken
     * @type {Set<string>}
     * @memberof CustomerAddModel
     */
    feature_groups_list?: Set<string>;
    /**
     * Reference of an external source [Optional]
     * @type {string}
     * @memberof CustomerAddModel
     */
    ext_reference?: string;
    /**
     * Additional reference of an external source [Optional]
     * @type {string}
     * @memberof CustomerAddModel
     */
    ext_reference_1?: string;
    /**
     * Source of the customer import [Optional]. The field will be ignored and overwritten, if the request is made by a technical user using a JWT.
     * @type {string}
     * @memberof CustomerAddModel
     */
    ext_source?: string;
    /**
     * If the customer is a whitelabel_partner you need to pass an unique application_name
     * @type {string}
     * @memberof CustomerAddModel
     */
    application_name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerAddModel
     */
    preInstallationGridXOnly?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum CustomerAddModelCustomerTypeEnum {
    ResidentialCustomer = 'residential_customer',
    Partner = 'partner',
    WhitelabelPartner = 'whitelabel_partner'
}
/**
* @export
* @enum {string}
*/
export enum CustomerAddModelCountryEnum {
    EnGb = 'en_GB',
    DeDe = 'de_DE',
    SvSe = 'sv_SE',
    ItIt = 'it_IT',
    PlPl = 'pl_PL',
    HuHu = 'hu_HU',
    CsCz = 'cs_CZ',
    HrHr = 'hr_HR',
    EnUk = 'en_UK',
    NlNl = 'nl_NL'
}
/**
* @export
* @enum {string}
*/
export enum CustomerAddModelLanguageEnum {
    En = 'en',
    De = 'de',
    Sv = 'sv',
    It = 'it',
    Pl = 'pl',
    Hu = 'hu',
    Cs = 'cs',
    Hr = 'hr',
    Nl = 'nl'
}

/**
 * 
 * @export
 * @interface CustomerBasicResponseModel
 */
export interface CustomerBasicResponseModel {
    /**
     * 
     * @type {string}
     * @memberof CustomerBasicResponseModel
     */
    id?: string;
    /**
     * 
     * @type {NameModel}
     * @memberof CustomerBasicResponseModel
     */
    name?: NameModel;
    /**
     * 
     * @type {string}
     * @memberof CustomerBasicResponseModel
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerBasicResponseModel
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerBasicResponseModel
     */
    language?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerBasicResponseModel
     */
    hasSales?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomerBasicResponseModel
     */
    tenant_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerBasicResponseModel
     */
    created_on?: string;
    /**
     * Reference of an external source [Optional]
     * @type {string}
     * @memberof CustomerBasicResponseModel
     */
    ext_reference?: string;
    /**
     * Reference of external1 source [Optional]
     * @type {string}
     * @memberof CustomerBasicResponseModel
     */
    ext_reference_1?: string;
    /**
     * Source of the customer import [Optional]
     * @type {string}
     * @memberof CustomerBasicResponseModel
     */
    ext_source?: string;
}
/**
 * 
 * @export
 * @interface CustomerChangeSubscriptionsModel
 */
export interface CustomerChangeSubscriptionsModel {
    /**
     * 
     * @type {Set<string>}
     * @memberof CustomerChangeSubscriptionsModel
     */
    feature_groups_list: Set<string>;
}
/**
 * 
 * @export
 * @interface CustomerChangeTenantModel
 */
export interface CustomerChangeTenantModel {
    /**
     * Move a customer to another parent account within tenant scope.
     * @type {string}
     * @memberof CustomerChangeTenantModel
     */
    newTenantId?: string;
}
/**
 * 
 * @export
 * @interface CustomerCompareModel
 */
export interface CustomerCompareModel {
    /**
     * 
     * @type {PlotableModel}
     * @memberof CustomerCompareModel
     */
    plottable?: PlotableModel;
    /**
     * 
     * @type {ComparableModel}
     * @memberof CustomerCompareModel
     */
    comparable?: ComparableModel;
}
/**
 * 
 * @export
 * @interface CustomerDeactivateModel
 */
export interface CustomerDeactivateModel {
    /**
     * Email of the customer account to be deactivated
     * @type {string}
     * @memberof CustomerDeactivateModel
     */
    confirmation: string;
}
/**
 * 
 * @export
 * @interface CustomerFeatureGroupResponseModel
 */
export interface CustomerFeatureGroupResponseModel {
    /**
     * 
     * @type {Array}
     * @memberof CustomerFeatureGroupResponseModel
     */
    feature_groups_list: Array<any>;
    /**
     * 
     * @type {string}
     * @memberof CustomerFeatureGroupResponseModel
     */
    ext_reference: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerFeatureGroupResponseModel
     */
    ext_reference_1: string;
}
/**
 * 
 * @export
 * @interface CustomerFeatureGroupSubModel
 */
export interface CustomerFeatureGroupSubModel {
    /**
     * 
     * @type {number}
     * @memberof CustomerFeatureGroupSubModel
     */
    _id?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerFeatureGroupSubModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerFeatureGroupSubModel
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerFeatureGroupSubModel
     */
    display_name?: string;
}
/**
 * 
 * @export
 * @interface CustomerGatewayHealthResponseModel
 */
export interface CustomerGatewayHealthResponseModel {
    /**
     * 
     * @type {number}
     * @memberof CustomerGatewayHealthResponseModel
     */
    count: number;
    /**
     * 
     * @type {Array<CustomerGatewayResponseModel>}
     * @memberof CustomerGatewayHealthResponseModel
     */
    list: Array<CustomerGatewayResponseModel>;
}
/**
 * 
 * @export
 * @interface CustomerGatewayResponseModel
 */
export interface CustomerGatewayResponseModel {
    /**
     * 
     * @type {string}
     * @memberof CustomerGatewayResponseModel
     */
    siteId?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerGatewayResponseModel
     */
    customerId?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerGatewayResponseModel
     */
    deviceId?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerGatewayResponseModel
     */
    deviceType?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerGatewayResponseModel
     */
    level?: CustomerGatewayResponseModelLevelEnum;
    /**
     * Contains raw message from vendor gateway compared to level which is parsed value
     * @type {string}
     * @memberof CustomerGatewayResponseModel
     */
    deviceLevel?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerGatewayResponseModel
     */
    created_on?: string;
}

/**
* @export
* @enum {string}
*/
export enum CustomerGatewayResponseModelLevelEnum {
    Ok = 'ok',
    Warning = 'warning',
    Alerting = 'alerting',
    NoData = 'no_data'
}

/**
 * 
 * @export
 * @interface CustomerGlobalSites
 */
export interface CustomerGlobalSites {
    /**
     * 
     * @type {string}
     * @memberof CustomerGlobalSites
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerGlobalSites
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerGlobalSites
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerGlobalSites
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerGlobalSites
     */
    zipCode?: string;
}
/**
 * 
 * @export
 * @interface CustomerIdpProviderResponseModel
 */
export interface CustomerIdpProviderResponseModel {
    /**
     * 
     * @type {string}
     * @memberof CustomerIdpProviderResponseModel
     */
    id?: string;
    /**
     * Root URLs for the Dashboard APP based on the Whitelabel IDP provider, defaults to EON home
     * @type {Array}
     * @memberof CustomerIdpProviderResponseModel
     */
    dashboard_app_urls?: Array<any>;
    /**
     * Mobile app deep link protocol, based on the Whitelabel IDP provider
     * @type {string}
     * @memberof CustomerIdpProviderResponseModel
     */
    app_protocol?: string;
    /**
     * IDP provider Type. Can be eon-ciam
     * @type {string}
     * @memberof CustomerIdpProviderResponseModel
     */
    idpType?: string;
}
/**
 * 
 * @export
 * @interface CustomerParentModel
 */
export interface CustomerParentModel {
    /**
     * 
     * @type {string}
     * @memberof CustomerParentModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerParentModel
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface CustomerRemoveFeatureGroupModel
 */
export interface CustomerRemoveFeatureGroupModel {
    /**
     * 
     * @type {string}
     * @memberof CustomerRemoveFeatureGroupModel
     */
    feature_group_id: string;
}
/**
 * 
 * @export
 * @interface CustomerRemoveModel
 */
export interface CustomerRemoveModel {
    /**
     * Name of the customer account to be deleted
     * @type {string}
     * @memberof CustomerRemoveModel
     */
    confirmation: string;
    /**
     * ### Purge of Customer 
     *  If set to true it will remove the customer immediately, otherwise soft delete is in place. 
     * 
     * __Requires policy:__  
     * `policy/admin/customers:delete`
     * @type {boolean}
     * @memberof CustomerRemoveModel
     */
    purge?: boolean;
}
/**
 * 
 * @export
 * @interface CustomerResponseModel
 */
export interface CustomerResponseModel {
    /**
     * 
     * @type {string}
     * @memberof CustomerResponseModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerResponseModel
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerResponseModel
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerResponseModel
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerResponseModel
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerResponseModel
     */
    customer_type?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerResponseModel
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomerResponseModel
     */
    idpId?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerResponseModel
     */
    created_on?: string;
    /**
     * 
     * @type {CreatedByModel}
     * @memberof CustomerResponseModel
     */
    created_by?: CreatedByModel;
    /**
     * 
     * @type {string}
     * @memberof CustomerResponseModel
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerResponseModel
     */
    deleted_by?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerResponseModel
     */
    deleted_on?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerResponseModel
     */
    modified_on?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerResponseModel
     */
    idp_status?: string;
    /**
     * 
     * @type {CustomerParentModel}
     * @memberof CustomerResponseModel
     */
    parent?: CustomerParentModel;
    /**
     * 
     * @type {string}
     * @memberof CustomerResponseModel
     */
    first_login?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerResponseModel
     */
    last_login?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerResponseModel
     */
    multiFactorAuthentication?: boolean;
    /**
     * Reference of an external source [Optional]
     * @type {string}
     * @memberof CustomerResponseModel
     */
    ext_reference?: string;
    /**
     * Additional reference of an external source [Optional]
     * @type {string}
     * @memberof CustomerResponseModel
     */
    ext_reference_1?: string;
    /**
     * Source of the customer import [Optional]
     * @type {string}
     * @memberof CustomerResponseModel
     */
    ext_source?: string;
    /**
     * 
     * @type {Array<CustomerFeatureGroupSubModel>}
     * @memberof CustomerResponseModel
     */
    feature_groups_list?: Array<CustomerFeatureGroupSubModel>;
    /**
     * 
     * @type {Array<CustomerSites>}
     * @memberof CustomerResponseModel
     */
    sites?: Array<CustomerSites>;
    /**
     * Only returned when csvExport=true AND idp_status != "registered" AND idpContext.type != "eon-auth0"
     * @type {string}
     * @memberof CustomerResponseModel
     */
    invite_link?: string;
    /**
     * Only returned when csvExport=true parameter is provided
     * @type {string}
     * @memberof CustomerResponseModel
     */
    zip_code?: string;
    /**
     * Only returned when csvExport=true parameter is provided
     * @type {string}
     * @memberof CustomerResponseModel
     */
    city?: string;
    /**
     * 
     * @type {CustomerVendorAllocationSubModel}
     * @memberof CustomerResponseModel
     */
    vendorAllocation?: CustomerVendorAllocationSubModel;
}
/**
 * 
 * @export
 * @interface CustomerSignupUrlResponseModel
 */
export interface CustomerSignupUrlResponseModel {
    /**
     * 
     * @type {string}
     * @memberof CustomerSignupUrlResponseModel
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerSignupUrlResponseModel
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerSignupUrlResponseModel
     */
    signupUri: string;
}
/**
 * 
 * @export
 * @interface CustomerSites
 */
export interface CustomerSites {
    /**
     * 
     * @type {string}
     * @memberof CustomerSites
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerSites
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface CustomerStats
 */
export interface CustomerStats {
    /**
     * 
     * @type {number}
     * @memberof CustomerStats
     */
    total?: number;
    /**
     * 
     * @type {Array<DataStatusModel>}
     * @memberof CustomerStats
     */
    data?: Array<DataStatusModel>;
    /**
     * 
     * @type {RegistrationModel}
     * @memberof CustomerStats
     */
    registration?: RegistrationModel;
    /**
     * 
     * @type {Array<StatsVendorResponseModel>}
     * @memberof CustomerStats
     */
    vendors?: Array<StatsVendorResponseModel>;
}
/**
 * 
 * @export
 * @interface CustomerStatsChildren
 */
export interface CustomerStatsChildren {
    /**
     * 
     * @type {Array<DataStatusModelChildren>}
     * @memberof CustomerStatsChildren
     */
    data?: Array<DataStatusModelChildren>;
}
/**
 * 
 * @export
 * @interface CustomerStatsFilter
 */
export interface CustomerStatsFilter {
    /**
     * 
     * @type {string}
     * @memberof CustomerStatsFilter
     */
    installation?: CustomerStatsFilterInstallationEnum;
    /**
     * 
     * @type {CustomersFilterName}
     * @memberof CustomerStatsFilter
     */
    vendor?: CustomersFilterName;
    /**
     * 
     * @type {CustomersFilterName}
     * @memberof CustomerStatsFilter
     */
    inverterType?: CustomersFilterName;
}

/**
* @export
* @enum {string}
*/
export enum CustomerStatsFilterInstallationEnum {
    Inverter = 'Inverter',
    Ev = 'EV',
    Heatpump = 'Heatpump',
    Sphere = 'Sphere',
    Smarthome = 'smarthome',
    Meter = 'Meter',
    NoConfiguration = 'noConfiguration',
    Gas = 'Gas',
    ElectricCar = 'ElectricCar'
}

/**
 * 
 * @export
 * @interface CustomerTypeModel
 */
export interface CustomerTypeModel {
    /**
     * 
     * @type {string}
     * @memberof CustomerTypeModel
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerTypeModel
     */
    displayName?: string;
}
/**
 * 
 * @export
 * @interface CustomerUpdateModel
 */
export interface CustomerUpdateModel {
    /**
     * Reference of an external source
     * @type {string}
     * @memberof CustomerUpdateModel
     */
    ext_reference?: string;
    /**
     * Additional reference of an external source [Optional]
     * @type {string}
     * @memberof CustomerUpdateModel
     */
    ext_reference_1?: string;
    /**
     * 
     * @type {NameModel}
     * @memberof CustomerUpdateModel
     */
    name?: NameModel;
}
/**
 * 
 * @export
 * @interface CustomerUserMainResponseModel
 */
export interface CustomerUserMainResponseModel {
    /**
     * 
     * @type {string}
     * @memberof CustomerUserMainResponseModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerUserMainResponseModel
     */
    username: string;
    /**
     * 
     * @type {NameModel}
     * @memberof CustomerUserMainResponseModel
     */
    name: NameModel;
}
/**
 * 
 * @export
 * @interface CustomerUserResponseModel
 */
export interface CustomerUserResponseModel {
    /**
     * 
     * @type {string}
     * @memberof CustomerUserResponseModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerUserResponseModel
     */
    username: string;
    /**
     * 
     * @type {NameModel}
     * @memberof CustomerUserResponseModel
     */
    name: NameModel;
    /**
     * 
     * @type {string}
     * @memberof CustomerUserResponseModel
     */
    inviteLink: string;
    /**
     * 
     * @type {Array<Consent>}
     * @memberof CustomerUserResponseModel
     */
    consents: Array<Consent>;
    /**
     * 
     * @type {string}
     * @memberof CustomerUserResponseModel
     */
    roles: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerUserResponseModel
     */
    created_on: string;
}
/**
 * 
 * @export
 * @interface CustomerUserUpdateModel
 */
export interface CustomerUserUpdateModel {
    /**
     * 
     * @type {string}
     * @memberof CustomerUserUpdateModel
     */
    username?: string;
}
/**
 * 
 * @export
 * @interface CustomerVendorAllocationSubModel
 */
export interface CustomerVendorAllocationSubModel {
    /**
     * 
     * @type {string}
     * @memberof CustomerVendorAllocationSubModel
     */
    vendorReferenceId?: string;
    /**
     * 
     * @type {VendorSubModel}
     * @memberof CustomerVendorAllocationSubModel
     */
    vendor?: VendorSubModel;
}
/**
 * 
 * @export
 * @interface CustomersFilter
 */
export interface CustomersFilter {
    /**
     * 
     * @type {CustomersFilterName}
     * @memberof CustomersFilter
     */
    name?: CustomersFilterName;
    /**
     * 
     * @type {CustomersFilterName}
     * @memberof CustomersFilter
     */
    email?: CustomersFilterName;
    /**
     * 
     * @type {CustomersFilterName}
     * @memberof CustomersFilter
     */
    tenant?: CustomersFilterName;
    /**
     * 
     * @type {CustomersFilterName}
     * @memberof CustomersFilter
     */
    idp_status?: CustomersFilterName;
    /**
     * 
     * @type {number}
     * @memberof CustomersFilter
     */
    status?: number;
    /**
     * 
     * @type {CustomersFilterName}
     * @memberof CustomersFilter
     */
    installation_status?: CustomersFilterName;
    /**
     * 
     * @type {CustomersFilterName}
     * @memberof CustomersFilter
     */
    customer_type?: CustomersFilterName;
    /**
     * 
     * @type {CustomersFilterSubscription}
     * @memberof CustomersFilter
     */
    subscription?: CustomersFilterSubscription;
    /**
     * 
     * @type {string}
     * @memberof CustomersFilter
     */
    ext_reference?: string;
}
/**
 * @type CustomersFilterName
 * 
 * @export
 */
export type CustomersFilterName = Array<string> | string;
/**
 * @type CustomersFilterSubscription
 * 
 * @export
 */
export type CustomersFilterSubscription = Array<string> | string;
/**
 * 
 * @export
 * @interface CustomersModel
 */
export interface CustomersModel {
    /**
     * 
     * @type {boolean}
     * @memberof CustomersModel
     */
    name: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomersModel
     */
    email: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomersModel
     */
    parent: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomersModel
     */
    created_on: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomersModel
     */
    joined_on: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomersModel
     */
    last_seen_on: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomersModel
     */
    status: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomersModel
     */
    type: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomersModel
     */
    subscriptionPackage: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomersModel
     */
    source: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomersModel
     */
    installation_status?: boolean;
}
/**
 * 
 * @export
 * @interface CustomersOrder
 */
export interface CustomersOrder {
    /**
     * 
     * @type {string}
     * @memberof CustomersOrder
     */
    by: CustomersOrderByEnum;
    /**
     * 
     * @type {string}
     * @memberof CustomersOrder
     */
    direction: CustomersOrderDirectionEnum;
}

/**
* @export
* @enum {string}
*/
export enum CustomersOrderByEnum {
    Email = 'email',
    Tenant = 'tenant',
    CreatedOn = 'created_on',
    Name = 'name',
    IdpStatus = 'idp_status',
    CustomerType = 'customer_type',
    Subscription = 'subscription',
    JoinedOn = 'joined_on',
    LastSeenOn = 'last_seen_on'
}
/**
* @export
* @enum {string}
*/
export enum CustomersOrderDirectionEnum {
    Asc = 'ASC',
    Desc = 'DESC',
}

/**
 * 
 * @export
 * @interface CustomersResponseModel
 */
export interface CustomersResponseModel {
    /**
     * 
     * @type {number}
     * @memberof CustomersResponseModel
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof CustomersResponseModel
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof CustomersResponseModel
     */
    limit: number;
    /**
     * 
     * @type {Array<CustomerResponseModel>}
     * @memberof CustomersResponseModel
     */
    list: Array<CustomerResponseModel>;
}
/**
 * 
 * @export
 * @interface DashboardAccessTokensModel
 */
export interface DashboardAccessTokensModel {
    /**
     * 
     * @type {string}
     * @memberof DashboardAccessTokensModel
     */
    token?: string;
    /**
     * 
     * @type {Array<AuthorizationResponseModel>}
     * @memberof DashboardAccessTokensModel
     */
    scopes?: Array<AuthorizationResponseModel>;
}
/**
 * 
 * @export
 * @interface DashboardFilterModel
 */
export interface DashboardFilterModel {
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardFilterModel
     */
    filters: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardFilterModel
     */
    installation: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardFilterModel
     */
    vendor: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardFilterModel
     */
    inverterType: Array<string>;
}
/**
 * 
 * @export
 * @interface DataImportRetrieveModel
 */
export interface DataImportRetrieveModel {
    /**
     * The Id of the configured site
     * @type {string}
     * @memberof DataImportRetrieveModel
     */
    configId: string;
    /**
     * The action the import should take
     * @type {string}
     * @memberof DataImportRetrieveModel
     */
    action: DataImportRetrieveModelActionEnum;
}

/**
* @export
* @enum {string}
*/
export enum DataImportRetrieveModelActionEnum {
    Reimport = 'reimport',
    ExtendHistoricalData = 'extendHistoricalData',
    SpecificTimeFrame = 'specificTimeFrame'
}

/**
 * 
 * @export
 * @interface DataInstallationChildrenModel
 */
export interface DataInstallationChildrenModel {
    /**
     * 
     * @type {string}
     * @memberof DataInstallationChildrenModel
     */
    display_name?: string;
    /**
     * 
     * @type {number}
     * @memberof DataInstallationChildrenModel
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface DataInstallationModel
 */
export interface DataInstallationModel {
    /**
     * 
     * @type {string}
     * @memberof DataInstallationModel
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof DataInstallationModel
     */
    count?: number;
    /**
     * 
     * @type {{ [key: string]: DataInstallationChildrenModel; }}
     * @memberof DataInstallationModel
     */
    children?: { [key: string]: DataInstallationChildrenModel; };
}
/**
 * 
 * @export
 * @interface DataStatusModel
 */
export interface DataStatusModel {
    /**
     * 
     * @type {string}
     * @memberof DataStatusModel
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof DataStatusModel
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface DataStatusModelChildren
 */
export interface DataStatusModelChildren {
    /**
     * 
     * @type {string}
     * @memberof DataStatusModelChildren
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof DataStatusModelChildren
     */
    count?: number;
    /**
     * 
     * @type {Array}
     * @memberof DataStatusModelChildren
     */
    children?: Array<any>;
}
/**
 * 
 * @export
 * @interface DetailedConsumptionModel
 */
export interface DetailedConsumptionModel {
    /**
     * 
     * @type {number}
     * @memberof DetailedConsumptionModel
     */
    directHousehold?: number;
    /**
     * 
     * @type {number}
     * @memberof DetailedConsumptionModel
     */
    heatPump?: number;
    /**
     * 
     * @type {number}
     * @memberof DetailedConsumptionModel
     */
    evCharging?: number;
    /**
     * 
     * @type {number}
     * @memberof DetailedConsumptionModel
     */
    heater?: number;
}
/**
 * 
 * @export
 * @interface DeviceApplianceKindsBody
 */
export interface DeviceApplianceKindsBody {
    /**
     * 
     * @type {string}
     * @memberof DeviceApplianceKindsBody
     */
    applianceId: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceApplianceKindsBody
     */
    kind: DeviceApplianceKindsBodyKindEnum;
}

/**
* @export
* @enum {string}
*/
export enum DeviceApplianceKindsBodyKindEnum {
    Hybrid = 'HYBRID',
    Pv = 'PV',
    Battery = 'BATTERY'
}

/**
 * 
 * @export
 * @interface DeviceApplianceKindsRequestModel
 */
export interface DeviceApplianceKindsRequestModel {
    /**
     * 
     * @type {Array<DeviceApplianceKindsBody>}
     * @memberof DeviceApplianceKindsRequestModel
     */
    appliances: Array<DeviceApplianceKindsBody>;
}
/**
 * 
 * @export
 * @interface DeviceApplianceKindsResponseModel
 */
export interface DeviceApplianceKindsResponseModel {
    /**
     * 
     * @type {string}
     * @memberof DeviceApplianceKindsResponseModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceApplianceKindsResponseModel
     */
    serialnumber?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceApplianceKindsResponseModel
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceApplianceKindsResponseModel
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceApplianceKindsResponseModel
     */
    kind?: DeviceApplianceKindsResponseModelKindEnum;
}

/**
* @export
* @enum {string}
*/
export enum DeviceApplianceKindsResponseModelKindEnum {
    Unknown = 'UNKNOWN',
    Hybrid = 'HYBRID',
    Pv = 'PV',
    Battery = 'BATTERY'
}

/**
 * 
 * @export
 * @interface DeviceCapabilities
 */
export interface DeviceCapabilities {
    /**
     * 
     * @type {Array}
     * @memberof DeviceCapabilities
     */
    read?: Array<any>;
    /**
     * 
     * @type {Array}
     * @memberof DeviceCapabilities
     */
    write?: Array<any>;
}
/**
 * 
 * @export
 * @interface DeviceGateway
 */
export interface DeviceGateway {
    /**
     * 
     * @type {string}
     * @memberof DeviceGateway
     */
    vendorName: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceGateway
     */
    identifier: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceGateway
     */
    dictionary: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceGateway
     */
    splitOperator: string;
    /**
     * 
     * @type {ConfigurationClientAccess}
     * @memberof DeviceGateway
     */
    clientAccess: ConfigurationClientAccess;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceGateway
     */
    hasBeenMigrated?: boolean;
}
/**
 * 
 * @export
 * @interface EVDeviceConfiguration
 */
export interface EVDeviceConfiguration {
    /**
     * 
     * @type {EVDeviceCurrent}
     * @memberof EVDeviceConfiguration
     */
    current?: EVDeviceCurrent;
    /**
     * 
     * @type {number}
     * @memberof EVDeviceConfiguration
     */
    powerOutput?: number;
    /**
     * 
     * @type {string}
     * @memberof EVDeviceConfiguration
     */
    manufacturer?: string;
    /**
     * 
     * @type {string}
     * @memberof EVDeviceConfiguration
     */
    model?: string;
    /**
     * 
     * @type {string}
     * @memberof EVDeviceConfiguration
     */
    firmware?: string;
}
/**
 * 
 * @export
 * @interface EVDeviceCurrent
 */
export interface EVDeviceCurrent {
    /**
     * 
     * @type {number}
     * @memberof EVDeviceCurrent
     */
    chargingLimitRecommendationStepSize: number;
    /**
     * 
     * @type {number}
     * @memberof EVDeviceCurrent
     */
    minimumOperationalThreshold: number;
}
/**
 * 
 * @export
 * @interface ElectricCarModelResponseModel
 */
export interface ElectricCarModelResponseModel {
    /**
     * 
     * @type {string}
     * @memberof ElectricCarModelResponseModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ElectricCarModelResponseModel
     */
    deviceType?: string;
    /**
     * 
     * @type {string}
     * @memberof ElectricCarModelResponseModel
     */
    deviceId?: string;
    /**
     * 
     * @type {object}
     * @memberof ElectricCarModelResponseModel
     */
    deviceConfiguration?: object;
    /**
     * 
     * @type {DeviceGateway}
     * @memberof ElectricCarModelResponseModel
     */
    deviceGateway?: DeviceGateway;
    /**
     * 
     * @type {string}
     * @memberof ElectricCarModelResponseModel
     */
    vendorName?: string;
    /**
     * 
     * @type {string}
     * @memberof ElectricCarModelResponseModel
     */
    createdOn?: string;
    /**
     * 
     * @type {string}
     * @memberof ElectricCarModelResponseModel
     */
    lastModified?: string;
}
/**
 * 
 * @export
 * @interface EmailCampaignDataModel
 */
export interface EmailCampaignDataModel {
    /**
     * 
     * @type {string}
     * @memberof EmailCampaignDataModel
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof EmailCampaignDataModel
     */
    campaignName: string;
}
/**
 * 
 * @export
 * @interface EmailCampaignHealthModel
 */
export interface EmailCampaignHealthModel {
    /**
     * 
     * @type {object}
     * @memberof EmailCampaignHealthModel
     */
    totalEmailsPerCampaign?: object;
    /**
     * 
     * @type {number}
     * @memberof EmailCampaignHealthModel
     */
    lastDayEmailsCount?: number;
    /**
     * 
     * @type {Array}
     * @memberof EmailCampaignHealthModel
     */
    lastDayEmailsInfo?: Array<any>;
}
/**
 * 
 * @export
 * @interface EmailUserDataModel
 */
export interface EmailUserDataModel {
    /**
     * 
     * @type {string}
     * @memberof EmailUserDataModel
     */
    customerId?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailUserDataModel
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailUserDataModel
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailUserDataModel
     */
    language?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailUserDataModel
     */
    parentName?: string;
}
/**
 * 
 * @export
 * @interface ErrorResponseModel
 */
export interface ErrorResponseModel {
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseModel
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseModel
     */
    msg?: string;
}
/**
 * 
 * @export
 * @interface FailedMediaInfoResponseEntry
 */
export interface FailedMediaInfoResponseEntry {
    /**
     * 
     * @type {string}
     * @memberof FailedMediaInfoResponseEntry
     */
    status?: FailedMediaInfoResponseEntryStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof FailedMediaInfoResponseEntry
     */
    error?: string;
}

/**
* @export
* @enum {string}
*/
export enum FailedMediaInfoResponseEntryStatusEnum {
    Failed = 'failed'
}

/**
 * 
 * @export
 * @interface FeatureAddUpdateModel
 */
export interface FeatureAddUpdateModel {
    /**
     * 
     * @type {string}
     * @memberof FeatureAddUpdateModel
     */
    action: FeatureAddUpdateModelActionEnum;
    /**
     * Example: PV forecast feature
     * @type {string}
     * @memberof FeatureAddUpdateModel
     */
    description?: string;
    /**
     * Example: policy/dashboard/pv/forecast
     * @type {string}
     * @memberof FeatureAddUpdateModel
     */
    resource: string;
    /**
     * Example: hems-dashboard
     * @type {string}
     * @memberof FeatureAddUpdateModel
     */
    application: string;
}

/**
* @export
* @enum {string}
*/
export enum FeatureAddUpdateModelActionEnum {
    Read = 'read',
    Write = 'write',
    Delete = 'delete'
}

/**
 * 
 * @export
 * @interface FeatureCommonResponseModel
 */
export interface FeatureCommonResponseModel {
    /**
     * 
     * @type {string}
     * @memberof FeatureCommonResponseModel
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof FeatureCommonResponseModel
     */
    featureId?: string;
}
/**
 * 
 * @export
 * @interface FeatureGroupAddUpdateModel
 */
export interface FeatureGroupAddUpdateModel {
    /**
     * 
     * @type {string}
     * @memberof FeatureGroupAddUpdateModel
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FeatureGroupAddUpdateModel
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof FeatureGroupAddUpdateModel
     */
    customerType?: string;
    /**
     * 
     * @type {string}
     * @memberof FeatureGroupAddUpdateModel
     */
    roleType?: FeatureGroupAddUpdateModelRoleTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureGroupAddUpdateModel
     */
    _public?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureGroupAddUpdateModel
     */
    _default?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum FeatureGroupAddUpdateModelRoleTypeEnum {
    Customer = 'customer',
    User = 'user',
    Both = 'both'
}

/**
 * 
 * @export
 * @interface FeatureGroupCommonResponseModel
 */
export interface FeatureGroupCommonResponseModel {
    /**
     * 
     * @type {string}
     * @memberof FeatureGroupCommonResponseModel
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof FeatureGroupCommonResponseModel
     */
    id?: string;
}
/**
 * 
 * @export
 * @interface FeatureGroupResponseModel
 */
export interface FeatureGroupResponseModel {
    /**
     * 
     * @type {string}
     * @memberof FeatureGroupResponseModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FeatureGroupResponseModel
     */
    name?: string;
    /**
     * Example: Premium Plan
     * @type {string}
     * @memberof FeatureGroupResponseModel
     */
    displayName?: string;
    /**
     * customer
     * @type {string}
     * @memberof FeatureGroupResponseModel
     */
    roleType?: FeatureGroupResponseModelRoleTypeEnum;
    /**
     * residential
     * @type {string}
     * @memberof FeatureGroupResponseModel
     */
    customerType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureGroupResponseModel
     */
    _public?: boolean;
    /**
     * Default feature group
     * @type {boolean}
     * @memberof FeatureGroupResponseModel
     */
    _default?: boolean;
    /**
     * Tags the feature group as editable. A feature group is only editable by the owner.
     * @type {boolean}
     * @memberof FeatureGroupResponseModel
     */
    editable?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum FeatureGroupResponseModelRoleTypeEnum {
    Customer = 'customer',
    User = 'user',
    Both = 'both'
}

/**
 * 
 * @export
 * @interface FeatureResponseModel
 */
export interface FeatureResponseModel {
    /**
     * 
     * @type {string}
     * @memberof FeatureResponseModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FeatureResponseModel
     */
    action?: FeatureResponseModelActionEnum;
    /**
     * Example: PV forecast feature
     * @type {string}
     * @memberof FeatureResponseModel
     */
    description?: string;
    /**
     * Example: policy/dashboard/pv/forecast
     * @type {string}
     * @memberof FeatureResponseModel
     */
    resource?: string;
    /**
     * Example: hems-dashboard
     * @type {string}
     * @memberof FeatureResponseModel
     */
    application?: string;
}

/**
* @export
* @enum {string}
*/
export enum FeatureResponseModelActionEnum {
    Read = 'read',
    Write = 'write',
    Delete = 'delete'
}

/**
 * 
 * @export
 * @interface FilterModel
 */
export interface FilterModel {
    /**
     * 
     * @type {CustomersModel}
     * @memberof FilterModel
     */
    customers?: CustomersModel;
    /**
     * 
     * @type {DashboardFilterModel}
     * @memberof FilterModel
     */
    dashboard?: DashboardFilterModel;
}
/**
 * 
 * @export
 * @interface Forbidden
 */
export interface Forbidden {
    /**
     * The error name
     * @type {string}
     * @memberof Forbidden
     */
    name: string;
    /**
     * An error message
     * @type {string}
     * @memberof Forbidden
     */
    message: string;
    /**
     * The status code of the exception
     * @type {number}
     * @memberof Forbidden
     */
    status: number;
    /**
     * A list of related errors
     * @type {Array<GenericError>}
     * @memberof Forbidden
     */
    errors?: Array<GenericError>;
    /**
     * The stack trace (only in development mode)
     * @type {string}
     * @memberof Forbidden
     */
    stack?: string;
}
/**
 * 
 * @export
 * @interface GatewayDeviceConfiguration
 */
export interface GatewayDeviceConfiguration {
    /**
     * GridX scanning state
     * @type {string}
     * @memberof GatewayDeviceConfiguration
     */
    scanningState?: GatewayDeviceConfigurationScanningStateEnum;
    /**
     * GridX deletion state
     * @type {string}
     * @memberof GatewayDeviceConfiguration
     */
    deletionState?: GatewayDeviceConfigurationDeletionStateEnum;
    /**
     * GridX unique identifier for a particular scan process
     * @type {string}
     * @memberof GatewayDeviceConfiguration
     */
    scanId?: string;
    /**
     * GridX timestamp of the scan action
     * @type {string}
     * @memberof GatewayDeviceConfiguration
     */
    lastScanDate?: string;
    /**
     * GridX flag if the system has been created outside E.ON Home
     * @type {boolean}
     * @memberof GatewayDeviceConfiguration
     */
    hasBeenMigrated?: boolean;
    /**
     * Is ToU readiness check
     * @type {boolean}
     * @memberof GatewayDeviceConfiguration
     */
    ToU?: boolean;
    /**
     * ToU readiness check failing reasons
     * @type {Array}
     * @memberof GatewayDeviceConfiguration
     */
    ToUReadinessReasons?: Array<any>;
}

/**
* @export
* @enum {string}
*/
export enum GatewayDeviceConfigurationScanningStateEnum {
    Done = 'done',
    Pending = 'pending',
    Failed = 'failed'
}
/**
* @export
* @enum {string}
*/
export enum GatewayDeviceConfigurationDeletionStateEnum {
    Pending = 'pending',
    Failed = 'failed'
}

/**
 * 
 * @export
 * @interface GatewayDeviceInstallationRequestModel
 */
export interface GatewayDeviceInstallationRequestModel {
    /**
     * 
     * @type {string}
     * @memberof GatewayDeviceInstallationRequestModel
     */
    deviceType?: string;
    /**
     * 
     * @type {VendorModel}
     * @memberof GatewayDeviceInstallationRequestModel
     */
    vendor?: VendorModel;
    /**
     * 
     * @type {string}
     * @memberof GatewayDeviceInstallationRequestModel
     */
    manufacturer?: string;
}
/**
 * 
 * @export
 * @interface GatewayResponseModel
 */
export interface GatewayResponseModel {
    /**
     * 
     * @type {string}
     * @memberof GatewayResponseModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GatewayResponseModel
     */
    deviceType?: string;
    /**
     * 
     * @type {string}
     * @memberof GatewayResponseModel
     */
    deviceId?: string;
    /**
     * 
     * @type {GatewayDeviceConfiguration}
     * @memberof GatewayResponseModel
     */
    deviceConfiguration?: GatewayDeviceConfiguration;
    /**
     * 
     * @type {DeviceGateway}
     * @memberof GatewayResponseModel
     */
    deviceGateway?: DeviceGateway;
    /**
     * 
     * @type {string}
     * @memberof GatewayResponseModel
     */
    vendorName?: string;
}
/**
 * 
 * @export
 * @interface GatewayToUReadinessResponseModel
 */
export interface GatewayToUReadinessResponseModel {
    /**
     * 
     * @type {object}
     * @memberof GatewayToUReadinessResponseModel
     */
    readiness?: object;
    /**
     * 
     * @type {string}
     * @memberof GatewayToUReadinessResponseModel
     */
    deviceId?: string;
    /**
     * 
     * @type {string}
     * @memberof GatewayToUReadinessResponseModel
     */
    deviceType?: string;
    /**
     * 
     * @type {string}
     * @memberof GatewayToUReadinessResponseModel
     */
    vendor?: string;
    /**
     * 
     * @type {string}
     * @memberof GatewayToUReadinessResponseModel
     */
    timestamp?: string;
}
/**
 * 
 * @export
 * @interface GenericError
 */
export interface GenericError {
    [key: string]: any | any;
    /**
     * The error name
     * @type {string}
     * @memberof GenericError
     */
    name: string;
    /**
     * An error message
     * @type {string}
     * @memberof GenericError
     */
    message: string;
}
/**
 * 
 * @export
 * @interface GridExchangeModel
 */
export interface GridExchangeModel {
    /**
     * 
     * @type {number}
     * @memberof GridExchangeModel
     */
    l1?: number;
    /**
     * 
     * @type {number}
     * @memberof GridExchangeModel
     */
    l2?: number;
    /**
     * 
     * @type {number}
     * @memberof GridExchangeModel
     */
    l3?: number;
    /**
     * 
     * @type {number}
     * @memberof GridExchangeModel
     */
    total?: number;
}
/**
 * 
 * @export
 * @interface GridXAppliance
 */
export interface GridXAppliance {
    /**
     * 
     * @type {string}
     * @memberof GridXAppliance
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GridXAppliance
     */
    type: GridXApplianceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GridXAppliance
     */
    kind: GridXApplianceKindEnum;
}

/**
* @export
* @enum {string}
*/
export enum GridXApplianceTypeEnum {
    Unknown = 'UNKNOWN',
    Inverter = 'INVERTER',
    Meter = 'METER',
    Battery = 'BATTERY',
    Evstation = 'EVSTATION',
    HeatPump = 'HEAT_PUMP'
}
/**
* @export
* @enum {string}
*/
export enum GridXApplianceKindEnum {
    Unknown = 'UNKNOWN',
    Pv = 'PV',
    PvExternal = 'PV_EXTERNAL',
    Battery = 'BATTERY',
    Hybrid = 'HYBRID',
    Grid = 'GRID',
    HeatPump = 'HEAT_PUMP',
    FuelCell = 'FUEL_CELL',
    HeatPumpExternal = 'HEAT_PUMP_EXTERNAL',
    Evstation = 'EVSTATION',
    Bttp = 'BTTP',
    Heating = 'HEATING',
    Misc = 'MISC',
    Cluster = 'CLUSTER',
    WindTurbine = 'WIND_TURBINE'
}

/**
 * 
 * @export
 * @interface GridXMeterInstallationRequestModel
 */
export interface GridXMeterInstallationRequestModel {
    /**
     * 
     * @type {string}
     * @memberof GridXMeterInstallationRequestModel
     */
    kind: GridXMeterInstallationRequestModelKindEnum;
}

/**
* @export
* @enum {string}
*/
export enum GridXMeterInstallationRequestModelKindEnum {
    Unknown = 'UNKNOWN',
    Pv = 'PV',
    PvExternal = 'PV_EXTERNAL',
    Battery = 'BATTERY',
    Hybrid = 'HYBRID',
    Grid = 'GRID',
    HeatPump = 'HEAT_PUMP',
    FuelCell = 'FUEL_CELL',
    HeatPumpExternal = 'HEAT_PUMP_EXTERNAL',
    Evstation = 'EVSTATION',
    Bttp = 'BTTP',
    Heating = 'HEATING',
    Misc = 'MISC',
    Cluster = 'CLUSTER',
    WindTurbine = 'WIND_TURBINE'
}

/**
 * 
 * @export
 * @interface HealthRequestItems
 */
export interface HealthRequestItems {
    /**
     * 
     * @type {string}
     * @memberof HealthRequestItems
     */
    customerId?: string;
}
/**
 * 
 * @export
 * @interface HealthStatusAlarmItem
 */
export interface HealthStatusAlarmItem {
    /**
     * 
     * @type {string}
     * @memberof HealthStatusAlarmItem
     */
    customerId?: string;
    /**
     * 
     * @type {string}
     * @memberof HealthStatusAlarmItem
     */
    siteId?: string;
    /**
     * 
     * @type {string}
     * @memberof HealthStatusAlarmItem
     */
    status: HealthStatusAlarmItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof HealthStatusAlarmItem
     */
    timestamp?: string;
}

/**
* @export
* @enum {string}
*/
export enum HealthStatusAlarmItemStatusEnum {
    Warning = 'warning',
    Error = 'error',
    NoData = 'no_data'
}

/**
 * 
 * @export
 * @interface HealthStatusAlarmsItem
 */
export interface HealthStatusAlarmsItem {
    /**
     * 
     * @type {string}
     * @memberof HealthStatusAlarmsItem
     */
    alarmId?: string;
    /**
     * 
     * @type {string}
     * @memberof HealthStatusAlarmsItem
     */
    level?: HealthStatusAlarmsItemLevelEnum;
    /**
     * 
     * @type {string}
     * @memberof HealthStatusAlarmsItem
     */
    timestamp?: string;
}

/**
* @export
* @enum {string}
*/
export enum HealthStatusAlarmsItemLevelEnum {
    Ok = 'ok',
    Warning = 'warning',
    Error = 'error'
}

/**
 * 
 * @export
 * @interface HealthStatusAlarmsModel
 */
export interface HealthStatusAlarmsModel {
    /**
     * 
     * @type {number}
     * @memberof HealthStatusAlarmsModel
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof HealthStatusAlarmsModel
     */
    alarmLevel?: HealthStatusAlarmsModelAlarmLevelEnum;
    /**
     * 
     * @type {Array<HealthStatusAlarmItem>}
     * @memberof HealthStatusAlarmsModel
     */
    list: Array<HealthStatusAlarmItem>;
}

/**
* @export
* @enum {string}
*/
export enum HealthStatusAlarmsModelAlarmLevelEnum {
    Warning = 'warning',
    Error = 'error',
    NoData = 'no_data'
}

/**
 * 
 * @export
 * @interface HealthStatusItem
 */
export interface HealthStatusItem {
    /**
     * 
     * @type {string}
     * @memberof HealthStatusItem
     */
    siteId?: string;
    /**
     * 
     * @type {string}
     * @memberof HealthStatusItem
     */
    status?: HealthStatusItemStatusEnum;
    /**
     * 
     * @type {Array<HealthStatusAlarmsItem>}
     * @memberof HealthStatusItem
     */
    alarms?: Array<HealthStatusAlarmsItem>;
    /**
     * 
     * @type {string}
     * @memberof HealthStatusItem
     */
    deviceId?: string;
    /**
     * 
     * @type {string}
     * @memberof HealthStatusItem
     */
    deviceType?: string;
    /**
     * 
     * @type {string}
     * @memberof HealthStatusItem
     */
    timestamp?: string;
}

/**
* @export
* @enum {string}
*/
export enum HealthStatusItemStatusEnum {
    Ok = 'ok',
    Warning = 'warning',
    Error = 'error',
    NoData = 'no_data',
    NotApplicable = 'not_applicable'
}

/**
 * 
 * @export
 * @interface HealthStatusList
 */
export interface HealthStatusList {
    /**
     * 
     * @type {string}
     * @memberof HealthStatusList
     */
    customerId?: string;
    /**
     * 
     * @type {Array<HealthStatusItem>}
     * @memberof HealthStatusList
     */
    sites: Array<HealthStatusItem>;
}
/**
 * 
 * @export
 * @interface HealthStatusModel
 */
export interface HealthStatusModel {
    /**
     * 
     * @type {number}
     * @memberof HealthStatusModel
     */
    count: number;
    /**
     * 
     * @type {Array<HealthStatusList>}
     * @memberof HealthStatusModel
     */
    list: Array<HealthStatusList>;
}
/**
 * 
 * @export
 * @interface HealthStatusRequest
 */
export interface HealthStatusRequest {
    /**
     * 
     * @type {Array<HealthRequestItems>}
     * @memberof HealthStatusRequest
     */
    customers: Array<HealthRequestItems>;
}
/**
 * 
 * @export
 * @interface HeatPumpDeviceConfigurationModel
 */
export interface HeatPumpDeviceConfigurationModel {
    /**
     * 
     * @type {HeatPumpInformation}
     * @memberof HeatPumpDeviceConfigurationModel
     */
    heatPump?: HeatPumpInformation;
    /**
     * 
     * @type {string}
     * @memberof HeatPumpDeviceConfigurationModel
     */
    manufacturer?: string;
    /**
     * 
     * @type {string}
     * @memberof HeatPumpDeviceConfigurationModel
     */
    model?: string;
    /**
     * 
     * @type {string}
     * @memberof HeatPumpDeviceConfigurationModel
     */
    firmware?: string;
    /**
     * 
     * @type {string}
     * @memberof HeatPumpDeviceConfigurationModel
     */
    readingStartDate?: string;
}
/**
 * 
 * @export
 * @interface HeatPumpDeviceModel
 */
export interface HeatPumpDeviceModel {
    /**
     * 
     * @type {string}
     * @memberof HeatPumpDeviceModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof HeatPumpDeviceModel
     */
    creationTime?: string;
    /**
     * 
     * @type {string}
     * @memberof HeatPumpDeviceModel
     */
    deviceId?: string;
    /**
     * 
     * @type {string}
     * @memberof HeatPumpDeviceModel
     */
    deviceType?: HeatPumpDeviceModelDeviceTypeEnum;
    /**
     * 
     * @type {HeatPumpDeviceConfigurationModel}
     * @memberof HeatPumpDeviceModel
     */
    deviceConfiguration?: HeatPumpDeviceConfigurationModel;
    /**
     * 
     * @type {DeviceGateway}
     * @memberof HeatPumpDeviceModel
     */
    deviceGateway?: DeviceGateway;
    /**
     * 
     * @type {string}
     * @memberof HeatPumpDeviceModel
     */
    installationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof HeatPumpDeviceModel
     */
    vendorName?: string;
    /**
     * 
     * @type {string}
     * @memberof HeatPumpDeviceModel
     */
    lastModified?: string;
    /**
     * 
     * @type {string}
     * @memberof HeatPumpDeviceModel
     */
    createdOn?: string;
}

/**
* @export
* @enum {string}
*/
export enum HeatPumpDeviceModelDeviceTypeEnum {
    HeatPump = 'HEAT_PUMP'
}

/**
 * 
 * @export
 * @interface HeatPumpInformation
 */
export interface HeatPumpInformation {
    /**
     * 
     * @type {string}
     * @memberof HeatPumpInformation
     */
    type?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HeatPumpInformation
     */
    controllable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HeatPumpInformation
     */
    behindGCP?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HeatPumpInformation
     */
    withOwnTariff?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HeatPumpInformation
     */
    userControlEnabled?: boolean;
}
/**
 * 
 * @export
 * @interface HistoryConsent
 */
export interface HistoryConsent {
    /**
     * 
     * @type {string}
     * @memberof HistoryConsent
     */
    version: string;
    /**
     * 
     * @type {string}
     * @memberof HistoryConsent
     */
    publishDate: string;
}
/**
 * 
 * @export
 * @interface IdpProvider
 */
export interface IdpProvider {
    /**
     * 
     * @type {number}
     * @memberof IdpProvider
     */
    _id: number;
    /**
     * 
     * @type {number}
     * @memberof IdpProvider
     */
    tenant_affiliate_id: number;
    /**
     * 
     * @type {number}
     * @memberof IdpProvider
     */
    tenant_id: number;
    /**
     * 
     * @type {string}
     * @memberof IdpProvider
     */
    tenant_uuid: string;
    /**
     * 
     * @type {string}
     * @memberof IdpProvider
     */
    tenant_name: string;
    /**
     * 
     * @type {string}
     * @memberof IdpProvider
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof IdpProvider
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof IdpProvider
     */
    app_protocol: string;
    /**
     * 
     * @type {IdpProviderSettings}
     * @memberof IdpProvider
     */
    settings?: IdpProviderSettings;
}
/**
 * @type IdpProviderSettings
 * 
 * @export
 */
export type IdpProviderSettings = Auth0ContextSettings | CiamContextSettings | CognitoContextSettings;
/**
 * 
 * @export
 * @interface IdpSignUpRequestModel
 */
export interface IdpSignUpRequestModel {
    /**
     * 
     * @type {string}
     * @memberof IdpSignUpRequestModel
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof IdpSignUpRequestModel
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof IdpSignUpRequestModel
     */
    application: IdpSignUpRequestModelApplicationEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IdpSignUpRequestModel
     */
    consentTermsOfUse: boolean;
    /**
     * 
     * @type {string}
     * @memberof IdpSignUpRequestModel
     */
    consentTermsOfUseVersion: string;
    /**
     * 
     * @type {boolean}
     * @memberof IdpSignUpRequestModel
     */
    consentSupport: boolean;
    /**
     * 
     * @type {string}
     * @memberof IdpSignUpRequestModel
     */
    consentSupportVersion: string;
}

/**
* @export
* @enum {string}
*/
export enum IdpSignUpRequestModelApplicationEnum {
    Admin = 'admin',
    Dashboard = 'dashboard'
}

/**
 * 
 * @export
 * @interface ImageMetadata
 */
export interface ImageMetadata {
    /**
     * 
     * @type {number}
     * @memberof ImageMetadata
     */
    width?: number;
    /**
     * 
     * @type {number}
     * @memberof ImageMetadata
     */
    height?: number;
}
/**
 * 
 * @export
 * @interface InstallationLiveDataResponseModel
 */
export interface InstallationLiveDataResponseModel {
    /**
     * 
     * @type {SummaryModel}
     * @memberof InstallationLiveDataResponseModel
     */
    summary?: SummaryModel;
    /**
     * 
     * @type {DetailedConsumptionModel}
     * @memberof InstallationLiveDataResponseModel
     */
    detailedConsumption?: DetailedConsumptionModel;
    /**
     * 
     * @type {GridExchangeModel}
     * @memberof InstallationLiveDataResponseModel
     */
    gridExchange?: GridExchangeModel;
}
/**
 * 
 * @export
 * @interface InstallationOpt
 */
export interface InstallationOpt {
    /**
     * 
     * @type {string}
     * @memberof InstallationOpt
     */
    start_code?: string;
}
/**
 * 
 * @export
 * @interface InstallationRequestModel
 */
export interface InstallationRequestModel {
    /**
     * 
     * @type {BatteryModel}
     * @memberof InstallationRequestModel
     */
    battery?: BatteryModel;
    /**
     * 
     * @type {InverterModel}
     * @memberof InstallationRequestModel
     */
    inverter?: InverterModel;
    /**
     * 
     * @type {Array<PvPanel>}
     * @memberof InstallationRequestModel
     */
    panels?: Array<PvPanel>;
    /**
     * 
     * @type {VendorModel}
     * @memberof InstallationRequestModel
     */
    vendor?: VendorModel;
    /**
     * Add products attached to this installation such as SolarCloud [Optional]
     * @type {Array<ProductModel>}
     * @memberof InstallationRequestModel
     */
    products?: Array<ProductModel>;
    /**
     * The Date of the installation as isodate
     * @type {string}
     * @memberof InstallationRequestModel
     */
    installationDate?: string | null;
}
/**
 * 
 * @export
 * @interface InstallationResponseModel
 */
export interface InstallationResponseModel {
    /**
     * 
     * @type {Array<PVBatteryModel>}
     * @memberof InstallationResponseModel
     */
    pvBattery?: Array<PVBatteryModel>;
    /**
     * 
     * @type {Array<WallboxModel>}
     * @memberof InstallationResponseModel
     */
    wallbox?: Array<WallboxModel>;
    /**
     * 
     * @type {Array<MeterModel>}
     * @memberof InstallationResponseModel
     */
    meter?: Array<MeterModel>;
}
/**
 * 
 * @export
 * @interface InstallationSmartHomeResponse
 */
export interface InstallationSmartHomeResponse {
    /**
     * 
     * @type {string}
     * @memberof InstallationSmartHomeResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InstallationSmartHomeResponse
     */
    vendorName?: string;
    /**
     * 
     * @type {string}
     * @memberof InstallationSmartHomeResponse
     */
    installationId?: string;
    /**
     * 
     * @type {string}
     * @memberof InstallationSmartHomeResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof InstallationSmartHomeResponse
     */
    type?: string;
    /**
     * 
     * @type {DeviceCapabilities}
     * @memberof InstallationSmartHomeResponse
     */
    capabilities?: DeviceCapabilities;
}
/**
 * 
 * @export
 * @interface InstallationStatsModel
 */
export interface InstallationStatsModel {
    /**
     * 
     * @type {number}
     * @memberof InstallationStatsModel
     */
    total?: number;
    /**
     * 
     * @type {Array<DataInstallationModel>}
     * @memberof InstallationStatsModel
     */
    data?: Array<DataInstallationModel>;
    /**
     * 
     * @type {SmartEnergyInstallationsModel}
     * @memberof InstallationStatsModel
     */
    smartEnergyInstallations?: SmartEnergyInstallationsModel;
}
/**
 * 
 * @export
 * @interface InstallationUpdateModel
 */
export interface InstallationUpdateModel {
    /**
     * 
     * @type {BatteryModel}
     * @memberof InstallationUpdateModel
     */
    battery?: BatteryModel;
    /**
     * 
     * @type {InverterModel}
     * @memberof InstallationUpdateModel
     */
    inverter?: InverterModel;
    /**
     * 
     * @type {Array<PvPanel>}
     * @memberof InstallationUpdateModel
     */
    panels?: Array<PvPanel>;
    /**
     * 
     * @type {VendorModel}
     * @memberof InstallationUpdateModel
     */
    vendor?: VendorModel;
    /**
     * Add products attached to this installation such as SolarCloud [Optional]
     * @type {Array<ProductModel>}
     * @memberof InstallationUpdateModel
     */
    products?: Array<ProductModel>;
    /**
     * The date of the installation as isodate
     * @type {string}
     * @memberof InstallationUpdateModel
     */
    installationDate?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof InstallationUpdateModel
     */
    onlyPeakPowerUpdate?: boolean;
}
/**
 * 
 * @export
 * @interface InstallerCompaniesResponseModel
 */
export interface InstallerCompaniesResponseModel {
    /**
     * 
     * @type {number}
     * @memberof InstallerCompaniesResponseModel
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof InstallerCompaniesResponseModel
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof InstallerCompaniesResponseModel
     */
    limit?: number;
    /**
     * 
     * @type {Array<InstallerCompanyResponseModel>}
     * @memberof InstallerCompaniesResponseModel
     */
    list: Array<InstallerCompanyResponseModel>;
}
/**
 * 
 * @export
 * @interface InstallerCompanyRequestModel
 */
export interface InstallerCompanyRequestModel {
    /**
     * 
     * @type {string}
     * @memberof InstallerCompanyRequestModel
     */
    tenant_id: string;
    /**
     * 
     * @type {string}
     * @memberof InstallerCompanyRequestModel
     */
    name: string;
    /**
     * 
     * @type {object}
     * @memberof InstallerCompanyRequestModel
     */
    payload: object;
}
/**
 * 
 * @export
 * @interface InstallerCompanyResponseModel
 */
export interface InstallerCompanyResponseModel {
    /**
     * 
     * @type {string}
     * @memberof InstallerCompanyResponseModel
     */
    tenant_id: string;
    /**
     * 
     * @type {string}
     * @memberof InstallerCompanyResponseModel
     */
    name: string;
    /**
     * 
     * @type {object}
     * @memberof InstallerCompanyResponseModel
     */
    payload: object;
    /**
     * 
     * @type {string}
     * @memberof InstallerCompanyResponseModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InstallerCompanyResponseModel
     */
    created_on?: string;
    /**
     * 
     * @type {string}
     * @memberof InstallerCompanyResponseModel
     */
    modified_on?: string;
}
/**
 * 
 * @export
 * @interface InternalConsent
 */
export interface InternalConsent {
    /**
     * 
     * @type {string}
     * @memberof InternalConsent
     */
    name: InternalConsentNameEnum;
    /**
     * 
     * @type {boolean}
     * @memberof InternalConsent
     */
    opting: boolean;
    /**
     * 
     * @type {InternalConsentVersion}
     * @memberof InternalConsent
     */
    version: InternalConsentVersion;
    /**
     * 
     * @type {string}
     * @memberof InternalConsent
     */
    link?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalConsent
     */
    timestamp?: string;
}

/**
* @export
* @enum {string}
*/
export enum InternalConsentNameEnum {
    TermsOfUse = 'TermsOfUse',
    RemoteSupportAndManufacturer = 'RemoteSupportAndManufacturer',
    RemoteInstaller = 'RemoteInstaller'
}

/**
 * @type InternalConsentVersion
 * 
 * @export
 */
export type InternalConsentVersion = number | string;
/**
 * 
 * @export
 * @interface InternalServerError
 */
export interface InternalServerError {
    /**
     * The error name
     * @type {string}
     * @memberof InternalServerError
     */
    name: string;
    /**
     * An error message
     * @type {string}
     * @memberof InternalServerError
     */
    message: string;
    /**
     * The status code of the exception
     * @type {number}
     * @memberof InternalServerError
     */
    status: number;
    /**
     * A list of related errors
     * @type {Array<GenericError>}
     * @memberof InternalServerError
     */
    errors?: Array<GenericError>;
    /**
     * The stack trace (only in development mode)
     * @type {string}
     * @memberof InternalServerError
     */
    stack?: string;
}
/**
 * 
 * @export
 * @interface InverterModel
 */
export interface InverterModel {
    /**
     * 
     * @type {boolean}
     * @memberof InverterModel
     */
    installed?: boolean;
    /**
     * 
     * @type {number}
     * @memberof InverterModel
     */
    maxPower?: number;
    /**
     * 
     * @type {number}
     * @memberof InverterModel
     */
    pvPeakPower?: number;
    /**
     * 
     * @type {string}
     * @memberof InverterModel
     */
    provider?: string;
    /**
     * 
     * @type {string}
     * @memberof InverterModel
     */
    model?: string;
    /**
     * 
     * @type {string}
     * @memberof InverterModel
     */
    firmware?: string;
    /**
     * 
     * @type {string}
     * @memberof InverterModel
     */
    manufacturer?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InverterModel
     */
    gcp?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InverterModel
     */
    serialnumber?: string;
    /**
     * Used by GridX systems for Kostal inverters, awaiting master key input for enabling tcp/modbus network connection.
     * @type {string}
     * @memberof InverterModel
     */
    masterKey?: string;
}
/**
 * 
 * @export
 * @interface IoTCategoryModel
 */
export interface IoTCategoryModel {
    /**
     * 
     * @type {string}
     * @memberof IoTCategoryModel
     */
    category?: IoTCategoryModelCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof IoTCategoryModel
     */
    description?: string;
}

/**
* @export
* @enum {string}
*/
export enum IoTCategoryModelCategoryEnum {
    Ev = 'ev',
    Pvbattery = 'pvbattery',
    Iothub = 'iothub',
    Meter = 'meter'
}

/**
 * 
 * @export
 * @interface IoTVendorCategoryResponseModel
 */
export interface IoTVendorCategoryResponseModel {
    /**
     * 
     * @type {Array<IoTVendorModel>}
     * @memberof IoTVendorCategoryResponseModel
     */
    vendors?: Array<IoTVendorModel>;
    /**
     * 
     * @type {Array<IoTCategoryModel>}
     * @memberof IoTVendorCategoryResponseModel
     */
    categories?: Array<IoTCategoryModel>;
}
/**
 * 
 * @export
 * @interface IoTVendorField
 */
export interface IoTVendorField {
    /**
     * 
     * @type {string}
     * @memberof IoTVendorField
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IoTVendorField
     */
    api_key?: string;
}
/**
 * 
 * @export
 * @interface IoTVendorFilterModel
 */
export interface IoTVendorFilterModel {
    /**
     * Find vendors related only to this tenant
     * @type {string}
     * @memberof IoTVendorFilterModel
     */
    supportedTenantId?: string;
    /**
     * Find vendors related to this tenant or its descendants.
     * @type {string}
     * @memberof IoTVendorFilterModel
     */
    tenantId?: string;
}
/**
 * 
 * @export
 * @interface IoTVendorModel
 */
export interface IoTVendorModel {
    /**
     * 
     * @type {string}
     * @memberof IoTVendorModel
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IoTVendorModel
     */
    display_name?: string;
}
/**
 * 
 * @export
 * @interface IoTVendorPostModel
 */
export interface IoTVendorPostModel {
    /**
     * 
     * @type {string}
     * @memberof IoTVendorPostModel
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof IoTVendorPostModel
     */
    display_name: string;
    /**
     * 
     * @type {string}
     * @memberof IoTVendorPostModel
     */
    category: IoTVendorPostModelCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof IoTVendorPostModel
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof IoTVendorPostModel
     */
    secret?: string;
    /**
     * Vendor associated color HEX
     * @type {string}
     * @memberof IoTVendorPostModel
     */
    color?: string;
    /**
     * Required fields
     * @type {Array}
     * @memberof IoTVendorPostModel
     */
    vendor_fields?: Array<any>;
}

/**
* @export
* @enum {string}
*/
export enum IoTVendorPostModelCategoryEnum {
    Ev = 'ev',
    Pvbattery = 'pvbattery',
    Iothub = 'iothub',
    Meter = 'meter'
}

/**
 * 
 * @export
 * @interface IoTVendorPutModel
 */
export interface IoTVendorPutModel {
    /**
     * Token base64
     * @type {string}
     * @memberof IoTVendorPutModel
     */
    secret?: string;
    /**
     * HEX vendor color
     * @type {string}
     * @memberof IoTVendorPutModel
     */
    color?: string;
    /**
     * Required fields
     * @type {Array<IoTVendorField>}
     * @memberof IoTVendorPutModel
     */
    vendor_fields?: Array<IoTVendorField>;
}
/**
 * 
 * @export
 * @interface IoTVendorResponseModel
 */
export interface IoTVendorResponseModel {
    /**
     * 
     * @type {string}
     * @memberof IoTVendorResponseModel
     */
    id?: string;
    /**
     * The overall name of the vendor
     * @type {string}
     * @memberof IoTVendorResponseModel
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IoTVendorResponseModel
     */
    display_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IoTVendorResponseModel
     */
    category?: IoTVendorResponseModelCategoryEnum;
    /**
     * Name of the vendor if multiple accounts exists
     * @type {string}
     * @memberof IoTVendorResponseModel
     */
    vendor_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IoTVendorResponseModel
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof IoTVendorResponseModel
     */
    device_count?: number;
    /**
     * 
     * @type {string}
     * @memberof IoTVendorResponseModel
     */
    client_access_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IoTVendorResponseModel
     */
    client_access_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IoTVendorResponseModel
     */
    health?: string;
}

/**
* @export
* @enum {string}
*/
export enum IoTVendorResponseModelCategoryEnum {
    Ev = 'ev',
    Pvbattery = 'pvbattery',
    Iothub = 'iothub',
    Meter = 'meter',
    Gateway = 'gateway'
}

/**
 * 
 * @export
 * @interface IoTVendorResponseSimpleModel
 */
export interface IoTVendorResponseSimpleModel {
    /**
     * 
     * @type {string}
     * @memberof IoTVendorResponseSimpleModel
     */
    id?: string;
    /**
     * The overall name of the vendor
     * @type {string}
     * @memberof IoTVendorResponseSimpleModel
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IoTVendorResponseSimpleModel
     */
    display_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IoTVendorResponseSimpleModel
     */
    category?: IoTVendorResponseSimpleModelCategoryEnum;
    /**
     * Name of the vendor if multiple accounts exists
     * @type {string}
     * @memberof IoTVendorResponseSimpleModel
     */
    vendor_name?: string;
    /**
     * Vendor associated color HEX
     * @type {string}
     * @memberof IoTVendorResponseSimpleModel
     */
    color?: string;
    /**
     * Required fields
     * @type {Array<IoTVendorField>}
     * @memberof IoTVendorResponseSimpleModel
     */
    vendor_fields?: Array<IoTVendorField>;
}

/**
* @export
* @enum {string}
*/
export enum IoTVendorResponseSimpleModelCategoryEnum {
    Ev = 'ev',
    Pvbattery = 'pvbattery',
    Iothub = 'iothub',
    Meter = 'meter',
    Gateway = 'gateway'
}

/**
 * 
 * @export
 * @interface IoTVendorTenantPutModel
 */
export interface IoTVendorTenantPutModel {
    /**
     * 
     * @type {string}
     * @memberof IoTVendorTenantPutModel
     */
    tenant: string;
    /**
     * 
     * @type {string}
     * @memberof IoTVendorTenantPutModel
     */
    vendorReference: string;
    /**
     * 
     * @type {IoTVendorTenantPutModelScanConfigurations}
     * @memberof IoTVendorTenantPutModel
     */
    scanConfigurations?: IoTVendorTenantPutModelScanConfigurations;
}
/**
 * @type IoTVendorTenantPutModelScanConfigurations
 * Scanning configurations in list or JSON format
 * @export
 */
export type IoTVendorTenantPutModelScanConfigurations = Array<string> | object | string;
/**
 * 
 * @export
 * @interface IoTVendorTenantsResponseModel
 */
export interface IoTVendorTenantsResponseModel {
    /**
     * 
     * @type {string}
     * @memberof IoTVendorTenantsResponseModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof IoTVendorTenantsResponseModel
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IoTVendorTenantsResponseModel
     */
    vendorReference: string;
    /**
     * Scanning configurations in list format
     * @type {string}
     * @memberof IoTVendorTenantsResponseModel
     */
    scanConfigurations?: string;
}
/**
 * 
 * @export
 * @interface ItemFieldType
 */
export interface ItemFieldType {
    /**
     * 
     * @type {string}
     * @memberof ItemFieldType
     */
    type?: string;
    /**
     * 
     * @type {Array}
     * @memberof ItemFieldType
     */
    _enum?: Array<any>;
}
/**
 * 
 * @export
 * @interface ManagerReportOfBonusCustomersResponseModel
 */
export interface ManagerReportOfBonusCustomersResponseModel {
    /**
     * 
     * @type {Array}
     * @memberof ManagerReportOfBonusCustomersResponseModel
     */
    files?: Array<any>;
}
/**
 * 
 * @export
 * @interface ManagerReportOfDevicesConfigurationsResponseModel
 */
export interface ManagerReportOfDevicesConfigurationsResponseModel {
    /**
     * 
     * @type {string}
     * @memberof ManagerReportOfDevicesConfigurationsResponseModel
     */
    siteId?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerReportOfDevicesConfigurationsResponseModel
     */
    vendorName?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerReportOfDevicesConfigurationsResponseModel
     */
    deviceType?: ManagerReportOfDevicesConfigurationsResponseModelDeviceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ManagerReportOfDevicesConfigurationsResponseModel
     */
    creationTime?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerReportOfDevicesConfigurationsResponseModel
     */
    timezone?: string;
    /**
     * 
     * @type {number}
     * @memberof ManagerReportOfDevicesConfigurationsResponseModel
     */
    batteryCapacity?: number;
    /**
     * 
     * @type {number}
     * @memberof ManagerReportOfDevicesConfigurationsResponseModel
     */
    inverterPeak?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ManagerReportOfDevicesConfigurationsResponseModel
     */
    smartmeter?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ManagerReportOfDevicesConfigurationsResponseModel
     */
    gcpInstalled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ManagerReportOfDevicesConfigurationsResponseModel
     */
    product?: string;
}

/**
* @export
* @enum {string}
*/
export enum ManagerReportOfDevicesConfigurationsResponseModelDeviceTypeEnum {
    Inverter = 'Inverter',
    Meter = 'Meter',
    Ev = 'EV'
}

/**
 * 
 * @export
 * @interface ManagerReportOfUserActivityResponseModel
 */
export interface ManagerReportOfUserActivityResponseModel {
    /**
     * 
     * @type {string}
     * @memberof ManagerReportOfUserActivityResponseModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerReportOfUserActivityResponseModel
     */
    first_login?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerReportOfUserActivityResponseModel
     */
    last_login?: string;
    /**
     * 
     * @type {number}
     * @memberof ManagerReportOfUserActivityResponseModel
     */
    _id?: number;
    /**
     * 
     * @type {number}
     * @memberof ManagerReportOfUserActivityResponseModel
     */
    parent_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ManagerReportOfUserActivityResponseModel
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerReportOfUserActivityResponseModel
     */
    user_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ManagerReportOfUserActivityResponseModel
     */
    active?: boolean;
}
/**
 * 
 * @export
 * @interface Media
 */
export interface Media {
    /**
     * 
     * @type {string}
     * @memberof Media
     */
    fileId?: string;
    /**
     * 
     * @type {string}
     * @memberof Media
     */
    fileUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof Media
     */
    uploadedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Media
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof Media
     */
    fileName?: string;
    /**
     * 
     * @type {number}
     * @memberof Media
     */
    fileSize?: number;
    /**
     * 
     * @type {string}
     * @memberof Media
     */
    fileType?: string;
    /**
     * 
     * @type {object}
     * @memberof Media
     */
    metadata?: object;
}
/**
 * 
 * @export
 * @interface MediaInfo
 */
export interface MediaInfo {
    /**
     * 
     * @type {string}
     * @memberof MediaInfo
     */
    mimeType?: string;
    /**
     * 
     * @type {number}
     * @memberof MediaInfo
     */
    size?: number;
    /**
     * 
     * @type {ImageMetadata}
     * @memberof MediaInfo
     */
    metadata?: ImageMetadata;
}
/**
 * @type MediaInfoResponseMappingsValue
 * 
 * @export
 */
export type MediaInfoResponseMappingsValue = FailedMediaInfoResponseEntry | SuccessMediaInfoResponseEntry;
/**
 * 
 * @export
 * @interface Metadata
 */
export interface Metadata {
    /**
     * 
     * @type {string}
     * @memberof Metadata
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Metadata
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Metadata
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof Metadata
     */
    updatedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof Metadata
     */
    publishedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Metadata
     */
    publishedBy?: string;
    /**
     * 
     * @type {number}
     * @memberof Metadata
     */
    documentVersion?: number;
}
/**
 * 
 * @export
 * @interface MeterDeviceConfiguration
 */
export interface MeterDeviceConfiguration {
    /**
     * 
     * @type {string}
     * @memberof MeterDeviceConfiguration
     */
    fuelType: MeterDeviceConfigurationFuelTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof MeterDeviceConfiguration
     */
    billed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MeterDeviceConfiguration
     */
    gcp: boolean;
    /**
     * 
     * @type {string}
     * @memberof MeterDeviceConfiguration
     */
    manufacturer: string;
    /**
     * 
     * @type {string}
     * @memberof MeterDeviceConfiguration
     */
    firmware?: string;
    /**
     * 
     * @type {string}
     * @memberof MeterDeviceConfiguration
     */
    model?: string;
}

/**
* @export
* @enum {string}
*/
export enum MeterDeviceConfigurationFuelTypeEnum {
    Electricity = 'electricity',
    Gas = 'gas'
}

/**
 * 
 * @export
 * @interface MeterInstallationRequestModel
 */
export interface MeterInstallationRequestModel {
    /**
     * 
     * @type {string}
     * @memberof MeterInstallationRequestModel
     */
    customerNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof MeterInstallationRequestModel
     */
    installationIdConsumed?: string;
    /**
     * 
     * @type {string}
     * @memberof MeterInstallationRequestModel
     */
    installationIdProduced?: string;
    /**
     * 
     * @type {VendorModel}
     * @memberof MeterInstallationRequestModel
     */
    vendor?: VendorModel;
    /**
     * 
     * @type {string}
     * @memberof MeterInstallationRequestModel
     */
    manufacturer?: string;
}
/**
 * 
 * @export
 * @interface MeterModel
 */
export interface MeterModel {
    /**
     * 
     * @type {string}
     * @memberof MeterModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MeterModel
     */
    deviceType: string;
    /**
     * 
     * @type {string}
     * @memberof MeterModel
     */
    deviceId: string;
    /**
     * 
     * @type {MeterDeviceConfiguration}
     * @memberof MeterModel
     */
    deviceConfiguration: MeterDeviceConfiguration;
    /**
     * 
     * @type {DeviceGateway}
     * @memberof MeterModel
     */
    deviceGateway: DeviceGateway;
    /**
     * 
     * @type {string}
     * @memberof MeterModel
     */
    vendorName?: string;
    /**
     * 
     * @type {GridXAppliance}
     * @memberof MeterModel
     */
    gridXAppliance?: GridXAppliance;
}
/**
 * 
 * @export
 * @interface MeterResponseModel
 */
export interface MeterResponseModel {
    /**
     * 
     * @type {string}
     * @memberof MeterResponseModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MeterResponseModel
     */
    deviceType: string;
    /**
     * 
     * @type {string}
     * @memberof MeterResponseModel
     */
    deviceId: string;
    /**
     * 
     * @type {MeterDeviceConfiguration}
     * @memberof MeterResponseModel
     */
    deviceConfiguration: MeterDeviceConfiguration;
    /**
     * 
     * @type {DeviceGateway}
     * @memberof MeterResponseModel
     */
    deviceGateway: DeviceGateway;
    /**
     * 
     * @type {string}
     * @memberof MeterResponseModel
     */
    vendorName?: string;
    /**
     * 
     * @type {GridXAppliance}
     * @memberof MeterResponseModel
     */
    gridXAppliance?: GridXAppliance;
    /**
     * 
     * @type {string}
     * @memberof MeterResponseModel
     */
    createdOn: string;
    /**
     * 
     * @type {string}
     * @memberof MeterResponseModel
     */
    lastModified: string;
}
/**
 * 
 * @export
 * @interface MethodNotAllowed
 */
export interface MethodNotAllowed {
    /**
     * The error name
     * @type {string}
     * @memberof MethodNotAllowed
     */
    name: string;
    /**
     * An error message
     * @type {string}
     * @memberof MethodNotAllowed
     */
    message: string;
    /**
     * The status code of the exception
     * @type {number}
     * @memberof MethodNotAllowed
     */
    status: number;
    /**
     * A list of related errors
     * @type {Array<GenericError>}
     * @memberof MethodNotAllowed
     */
    errors?: Array<GenericError>;
    /**
     * The stack trace (only in development mode)
     * @type {string}
     * @memberof MethodNotAllowed
     */
    stack?: string;
}
/**
 * 
 * @export
 * @interface MultiFactorAddModel
 */
export interface MultiFactorAddModel {
    /**
     * 
     * @type {string}
     * @memberof MultiFactorAddModel
     */
    token: string;
}
/**
 * 
 * @export
 * @interface NameModel
 */
export interface NameModel {
    /**
     * 
     * @type {string}
     * @memberof NameModel
     */
    first?: string;
    /**
     * 
     * @type {string}
     * @memberof NameModel
     */
    last?: string;
}
/**
 * 
 * @export
 * @interface NotFound
 */
export interface NotFound {
    /**
     * The error name
     * @type {string}
     * @memberof NotFound
     */
    name: string;
    /**
     * An error message
     * @type {string}
     * @memberof NotFound
     */
    message: string;
    /**
     * The status code of the exception
     * @type {number}
     * @memberof NotFound
     */
    status: number;
    /**
     * A list of related errors
     * @type {Array<GenericError>}
     * @memberof NotFound
     */
    errors?: Array<GenericError>;
    /**
     * The stack trace (only in development mode)
     * @type {string}
     * @memberof NotFound
     */
    stack?: string;
}
/**
 * 
 * @export
 * @interface NotImplemented
 */
export interface NotImplemented {
    /**
     * The error name
     * @type {string}
     * @memberof NotImplemented
     */
    name: string;
    /**
     * An error message
     * @type {string}
     * @memberof NotImplemented
     */
    message: string;
    /**
     * The status code of the exception
     * @type {number}
     * @memberof NotImplemented
     */
    status: number;
    /**
     * A list of related errors
     * @type {Array<GenericError>}
     * @memberof NotImplemented
     */
    errors?: Array<GenericError>;
    /**
     * The stack trace (only in development mode)
     * @type {string}
     * @memberof NotImplemented
     */
    stack?: string;
}
/**
 * 
 * @export
 * @interface NotificationConfigAddModel
 */
export interface NotificationConfigAddModel {
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigAddModel
     */
    configType: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigAddModel
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigAddModel
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigAddModel
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigAddModel
     */
    source?: string;
    /**
     * 
     * @type {Array<NotificationConfigParameterDefinition>}
     * @memberof NotificationConfigAddModel
     */
    parameters?: Array<NotificationConfigParameterDefinition>;
    /**
     * 
     * @type {Array<NotificationConfigFilter>}
     * @memberof NotificationConfigAddModel
     */
    filters?: Array<NotificationConfigFilter>;
    /**
     * 
     * @type {Array<NotificationConfigRule>}
     * @memberof NotificationConfigAddModel
     */
    rules?: Array<NotificationConfigRule>;
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigAddModel
     */
    category: string;
    /**
     * 
     * @type {object}
     * @memberof NotificationConfigAddModel
     */
    schedulerDefinition?: object;
    /**
     * 
     * @type {Array<NotificationConfigEventDefinition>}
     * @memberof NotificationConfigAddModel
     */
    eventDefinition?: Array<NotificationConfigEventDefinition>;
    /**
     * 
     * @type {number}
     * @memberof NotificationConfigAddModel
     */
    storageTime?: number;
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigAddModel
     */
    correlation?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigAddModel
     */
    cmsSource?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigAddModel
     */
    kind?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigAddModel
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface NotificationConfigEventDefinition
 */
export interface NotificationConfigEventDefinition {
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigEventDefinition
     */
    treshold?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigEventDefinition
     */
    propName?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigEventDefinition
     */
    operation?: string;
}
/**
 * 
 * @export
 * @interface NotificationConfigFilter
 */
export interface NotificationConfigFilter {
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigFilter
     */
    variable: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigFilter
     */
    source: string;
}
/**
 * 
 * @export
 * @interface NotificationConfigParameterDefinition
 */
export interface NotificationConfigParameterDefinition {
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigParameterDefinition
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigParameterDefinition
     */
    source?: string;
    /**
     * 
     * @type {object}
     * @memberof NotificationConfigParameterDefinition
     */
    match?: object;
}
/**
 * 
 * @export
 * @interface NotificationConfigResponseModel
 */
export interface NotificationConfigResponseModel {
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigResponseModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigResponseModel
     */
    configType?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigResponseModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigResponseModel
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigResponseModel
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigResponseModel
     */
    source?: string;
    /**
     * 
     * @type {Array<NotificationConfigParameterDefinition>}
     * @memberof NotificationConfigResponseModel
     */
    parameters?: Array<NotificationConfigParameterDefinition>;
    /**
     * 
     * @type {Array<NotificationConfigFilter>}
     * @memberof NotificationConfigResponseModel
     */
    filters?: Array<NotificationConfigFilter>;
    /**
     * 
     * @type {Array<NotificationConfigRule>}
     * @memberof NotificationConfigResponseModel
     */
    rules?: Array<NotificationConfigRule>;
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigResponseModel
     */
    category?: string;
    /**
     * 
     * @type {object}
     * @memberof NotificationConfigResponseModel
     */
    schedulerDefinition?: object;
    /**
     * 
     * @type {Array<NotificationConfigEventDefinition>}
     * @memberof NotificationConfigResponseModel
     */
    eventDefinition?: Array<NotificationConfigEventDefinition>;
    /**
     * 
     * @type {number}
     * @memberof NotificationConfigResponseModel
     */
    storageTime?: number;
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigResponseModel
     */
    correlation?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigResponseModel
     */
    cmsSource?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigResponseModel
     */
    kind?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigResponseModel
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface NotificationConfigRule
 */
export interface NotificationConfigRule {
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigRule
     */
    variable: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationConfigRule
     */
    formula: string;
}
/**
 * 
 * @export
 * @interface OAuthClientCredentialsAddModel
 */
export interface OAuthClientCredentialsAddModel {
    /**
     * 
     * @type {string}
     * @memberof OAuthClientCredentialsAddModel
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof OAuthClientCredentialsAddModel
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface OAuthClientCredentialsGenerateResponse
 */
export interface OAuthClientCredentialsGenerateResponse {
    /**
     * 
     * @type {string}
     * @memberof OAuthClientCredentialsGenerateResponse
     */
    clientId?: string;
    /**
     * 
     * @type {string}
     * @memberof OAuthClientCredentialsGenerateResponse
     */
    clientSecret?: string;
    /**
     * 
     * @type {string}
     * @memberof OAuthClientCredentialsGenerateResponse
     */
    customerId?: string;
    /**
     * 
     * @type {string}
     * @memberof OAuthClientCredentialsGenerateResponse
     */
    createdOn?: string;
    /**
     * 
     * @type {string}
     * @memberof OAuthClientCredentialsGenerateResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof OAuthClientCredentialsGenerateResponse
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof OAuthClientCredentialsGenerateResponse
     */
    id?: string;
}
/**
 * 
 * @export
 * @interface OAuthClientCredentialsResetModel
 */
export interface OAuthClientCredentialsResetModel {
    /**
     * 
     * @type {string}
     * @memberof OAuthClientCredentialsResetModel
     */
    clientCredentialsId: string;
}
/**
 * 
 * @export
 * @interface OAuthClientCredentialsResponse
 */
export interface OAuthClientCredentialsResponse {
    /**
     * 
     * @type {string}
     * @memberof OAuthClientCredentialsResponse
     */
    clientId?: string;
    /**
     * 
     * @type {number}
     * @memberof OAuthClientCredentialsResponse
     */
    customerId?: number;
    /**
     * 
     * @type {string}
     * @memberof OAuthClientCredentialsResponse
     */
    createdOn?: string;
    /**
     * 
     * @type {string}
     * @memberof OAuthClientCredentialsResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof OAuthClientCredentialsResponse
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof OAuthClientCredentialsResponse
     */
    id?: string;
}
/**
 * 
 * @export
 * @interface OrderFieldModel
 */
export interface OrderFieldModel {
    /**
     * 
     * @type {string}
     * @memberof OrderFieldModel
     */
    field: string;
    /**
     * 
     * @type {string}
     * @memberof OrderFieldModel
     */
    direction: string;
}
/**
 * 
 * @export
 * @interface OrderModel
 */
export interface OrderModel {
    /**
     * 
     * @type {OrderFieldModel}
     * @memberof OrderModel
     */
    customers?: OrderFieldModel;
    /**
     * 
     * @type {OrderFieldModel}
     * @memberof OrderModel
     */
    members?: OrderFieldModel;
}
/**
 * 
 * @export
 * @interface PVBatteryModel
 */
export interface PVBatteryModel {
    /**
     * 
     * @type {string}
     * @memberof PVBatteryModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PVBatteryModel
     */
    deviceType?: string;
    /**
     * 
     * @type {string}
     * @memberof PVBatteryModel
     */
    deviceId?: string;
    /**
     * 
     * @type {PVDeviceConfiguration}
     * @memberof PVBatteryModel
     */
    deviceConfiguration?: PVDeviceConfiguration;
    /**
     * 
     * @type {DeviceGateway}
     * @memberof PVBatteryModel
     */
    deviceGateway?: DeviceGateway;
    /**
     * 
     * @type {string}
     * @memberof PVBatteryModel
     */
    installationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PVBatteryModel
     */
    vendorName?: string;
    /**
     * 
     * @type {string}
     * @memberof PVBatteryModel
     */
    lastModified?: string;
    /**
     * 
     * @type {string}
     * @memberof PVBatteryModel
     */
    createdOn?: string;
}
/**
 * 
 * @export
 * @interface PVBatteryResponseModel
 */
export interface PVBatteryResponseModel {
    /**
     * 
     * @type {string}
     * @memberof PVBatteryResponseModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PVBatteryResponseModel
     */
    deviceType?: string;
    /**
     * 
     * @type {string}
     * @memberof PVBatteryResponseModel
     */
    deviceId?: string;
    /**
     * 
     * @type {PVDeviceConfiguration}
     * @memberof PVBatteryResponseModel
     */
    deviceConfiguration?: PVDeviceConfiguration;
    /**
     * 
     * @type {DeviceGateway}
     * @memberof PVBatteryResponseModel
     */
    deviceGateway?: DeviceGateway;
    /**
     * 
     * @type {string}
     * @memberof PVBatteryResponseModel
     */
    installationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PVBatteryResponseModel
     */
    vendorName?: string;
    /**
     * 
     * @type {string}
     * @memberof PVBatteryResponseModel
     */
    lastModified?: string;
    /**
     * 
     * @type {string}
     * @memberof PVBatteryResponseModel
     */
    createdOn?: string;
}
/**
 * 
 * @export
 * @interface PVDeviceConfiguration
 */
export interface PVDeviceConfiguration {
    /**
     * 
     * @type {string}
     * @memberof PVDeviceConfiguration
     */
    kind?: string;
    /**
     * 
     * @type {string}
     * @memberof PVDeviceConfiguration
     */
    state?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PVDeviceConfiguration
     */
    isAwaitingMasterKey?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PVDeviceConfiguration
     */
    errMsg?: string;
    /**
     * 
     * @type {InverterModel}
     * @memberof PVDeviceConfiguration
     */
    inverter?: InverterModel;
    /**
     * 
     * @type {BatteryModel}
     * @memberof PVDeviceConfiguration
     */
    battery?: BatteryModel;
    /**
     * 
     * @type {Array<ProductModel>}
     * @memberof PVDeviceConfiguration
     */
    products?: Array<ProductModel>;
    /**
     * 
     * @type {Array<PvPanel>}
     * @memberof PVDeviceConfiguration
     */
    panels?: Array<PvPanel>;
    /**
     * 
     * @type {string}
     * @memberof PVDeviceConfiguration
     */
    readingStartDate?: string;
}
/**
 * 
 * @export
 * @interface PaginatedActivityLogResponse
 */
export interface PaginatedActivityLogResponse {
    /**
     * 
     * @type {number}
     * @memberof PaginatedActivityLogResponse
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedActivityLogResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedActivityLogResponse
     */
    limit: number;
    /**
     * 
     * @type {Array<ActivityLogResponseModel>}
     * @memberof PaginatedActivityLogResponse
     */
    list: Array<ActivityLogResponseModel>;
}
/**
 * 
 * @export
 * @interface PaginationModel
 */
export interface PaginationModel {
    /**
     * 
     * @type {number}
     * @memberof PaginationModel
     */
    customers: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationModel
     */
    members: number;
}
/**
 * 
 * @export
 * @interface PartialUpdateContentRequest
 */
export interface PartialUpdateContentRequest {
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateContentRequest
     */
    state?: PartialUpdateContentRequestStateEnum;
    /**
     * 
     * @type {number}
     * @memberof PartialUpdateContentRequest
     */
    order?: number;
    /**
     * 
     * @type {ContentFields}
     * @memberof PartialUpdateContentRequest
     */
    fields?: ContentFields;
}

/**
* @export
* @enum {string}
*/
export enum PartialUpdateContentRequestStateEnum {
    Draft = 'draft',
    Published = 'published',
    Freeze = 'freeze'
}

/**
 * 
 * @export
 * @interface PlotableModel
 */
export interface PlotableModel {
    /**
     * The plotable data from timescale db
     * @type {Array}
     * @memberof PlotableModel
     */
    timescaleDataPlottable?: Array<any>;
}
/**
 * 
 * @export
 * @interface PreferencesModel
 */
export interface PreferencesModel {
    /**
     * 
     * @type {string}
     * @memberof PreferencesModel
     */
    language?: PreferencesModelLanguageEnum;
    /**
     * 
     * @type {FilterModel}
     * @memberof PreferencesModel
     */
    filters?: FilterModel;
    /**
     * 
     * @type {OrderModel}
     * @memberof PreferencesModel
     */
    order?: OrderModel;
    /**
     * 
     * @type {PaginationModel}
     * @memberof PreferencesModel
     */
    pagination?: PaginationModel;
}

/**
* @export
* @enum {string}
*/
export enum PreferencesModelLanguageEnum {
    En = 'en',
    De = 'de',
    Sv = 'sv',
    It = 'it',
    Pl = 'pl',
    Hu = 'hu',
    Cs = 'cs',
    Hr = 'hr',
    Nl = 'nl'
}

/**
 * 
 * @export
 * @interface ProductModel
 */
export interface ProductModel {
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    end?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    tag?: string;
}
/**
 * 
 * @export
 * @interface ProfileMultifactorResponseModel
 */
export interface ProfileMultifactorResponseModel {
    /**
     * 
     * @type {string}
     * @memberof ProfileMultifactorResponseModel
     */
    otpauth_url?: string;
}
/**
 * 
 * @export
 * @interface ProfileRequestModel
 */
export interface ProfileRequestModel {
    /**
     * 
     * @type {NameModel}
     * @memberof ProfileRequestModel
     */
    name?: NameModel;
}
/**
 * 
 * @export
 * @interface ProfileResponseModel
 */
export interface ProfileResponseModel {
    /**
     * 
     * @type {string}
     * @memberof ProfileResponseModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponseModel
     */
    userId?: string;
    /**
     * 
     * @type {NameModel}
     * @memberof ProfileResponseModel
     */
    name?: NameModel;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponseModel
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponseModel
     */
    created_on?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponseModel
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponseModel
     */
    deleted_by?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponseModel
     */
    deleted_on?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponseModel
     */
    idp_status?: string;
    /**
     * 
     * @type {CustomerParentModel}
     * @memberof ProfileResponseModel
     */
    parent?: CustomerParentModel;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponseModel
     */
    first_login?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponseModel
     */
    last_login?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileResponseModel
     */
    multiFactorAuthentication?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponseModel
     */
    subscriptionPackage?: string;
    /**
     * 
     * @type {Array}
     * @memberof ProfileResponseModel
     */
    roles?: Array<any>;
}
/**
 * 
 * @export
 * @interface PvPanel
 */
export interface PvPanel {
    /**
     * 
     * @type {PvPanelOrientation}
     * @memberof PvPanel
     */
    orientation?: PvPanelOrientation;
    /**
     * Heigth above sea level of a location (panel). See: https://en.wikipedia.org/wiki/List_of_countries_by_average_elevation. Example: 'lat=51.42487516631922°, lon=6.9938371181706325°: altitude=113 m'
     * @type {number}
     * @memberof PvPanel
     */
    altitude?: number;
    /**
     * Number of panels with same orientation.
     * @type {number}
     * @memberof PvPanel
     */
    panelCount?: number;
    /**
     * Peak power value of all the panels of the same direction of an inverter. (We assume here that there is only one inverter for all the panels in all directions.)
     * @type {number}
     * @memberof PvPanel
     */
    peakPower: number;
    /**
     * 
     * @type {PvPanelShade}
     * @memberof PvPanel
     */
    shade?: PvPanelShade;
}
/**
 * 
 * @export
 * @interface PvPanelOrientation
 */
export interface PvPanelOrientation {
    /**
     * The tilt angle is the PV panel's orientation facing towards the zenith (point above your head). The lower the sun above the horizon the more effective is a large tilt. In MCS sunpath diagrams this would be relating to "sun height". Horizontal panel (facing the zenith): 0.0°; vertical panel (facing the horizon): 90.0°; default (in Germany): 30.0°
     * @type {number}
     * @memberof PvPanelOrientation
     */
    tilt: number;
    /**
     * The azimuth angle is the PV panel's orientation facing towards the south. South (default): 0.0°; East: -90.0°; West: 90.0°
     * @type {number}
     * @memberof PvPanelOrientation
     */
    azimuth: number;
}
/**
 * 
 * @export
 * @interface PvPanelShade
 */
export interface PvPanelShade {
    /**
     * Number of sunpath diagram segments that are affected by an object covering the sky. All the sun paths for a geo-location cover a part of the complete sky and this part can be itself be covered by objects. The sunpath diagram has around 100 segments. If you don't know you can leave this empty and just fill a value in shadeLevel. Depends on location and sky diagram! No sky coverage by objects: 0; horizon completely covered 15° above ground: 10; Sky completely covered: 85
     * @type {number}
     * @memberof PvPanelShade
     */
    shadedSegmentsCount?: number;
    /**
     * Ratio of how much the PV panels are covered by shadow on average. Calculate: shadedSegmentsCount/100.0. Never shade on panels: 0.00; default: 0.05; 11 segments affected: 11/100.0 = 0.11
     * @type {number}
     * @memberof PvPanelShade
     */
    shadeLevel?: number;
}
/**
 * 
 * @export
 * @interface RegistrationModel
 */
export interface RegistrationModel {
    /**
     * 
     * @type {number}
     * @memberof RegistrationModel
     */
    lastWeek?: number;
    /**
     * 
     * @type {number}
     * @memberof RegistrationModel
     */
    lastMonth?: number;
    /**
     * 
     * @type {number}
     * @memberof RegistrationModel
     */
    lastYear?: number;
}
/**
 * 
 * @export
 * @interface RequestEntityTooLarge
 */
export interface RequestEntityTooLarge {
    /**
     * The error name
     * @type {string}
     * @memberof RequestEntityTooLarge
     */
    name: string;
    /**
     * An error message
     * @type {string}
     * @memberof RequestEntityTooLarge
     */
    message: string;
    /**
     * The status code of the exception
     * @type {number}
     * @memberof RequestEntityTooLarge
     */
    status: number;
    /**
     * A list of related errors
     * @type {Array<GenericError>}
     * @memberof RequestEntityTooLarge
     */
    errors?: Array<GenericError>;
    /**
     * The stack trace (only in development mode)
     * @type {string}
     * @memberof RequestEntityTooLarge
     */
    stack?: string;
}
/**
 * 
 * @export
 * @interface SaleAddModel
 */
export interface SaleAddModel {
    /**
     * 
     * @type {string}
     * @memberof SaleAddModel
     */
    sale_template_id: string;
    /**
     * 
     * @type {Array<SaleTemplateStepEditModel>}
     * @memberof SaleAddModel
     */
    steps?: Array<SaleTemplateStepEditModel>;
}
/**
 * 
 * @export
 * @interface SaleEditModel
 */
export interface SaleEditModel {
    /**
     * 
     * @type {Array<SaleTemplateStepEditModel>}
     * @memberof SaleEditModel
     */
    steps?: Array<SaleTemplateStepEditModel>;
}
/**
 * 
 * @export
 * @interface SaleModel
 */
export interface SaleModel {
    /**
     * 
     * @type {string}
     * @memberof SaleModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SaleModel
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SaleModel
     */
    sale_template?: string;
    /**
     * 
     * @type {Array<SaleTemplateStepModel>}
     * @memberof SaleModel
     */
    steps?: Array<SaleTemplateStepModel>;
    /**
     * 
     * @type {string}
     * @memberof SaleModel
     */
    modified_on?: string;
    /**
     * 
     * @type {string}
     * @memberof SaleModel
     */
    deleted_by?: string;
}
/**
 * 
 * @export
 * @interface SaleTemplateAllocatedTenantsModel
 */
export interface SaleTemplateAllocatedTenantsModel {
    /**
     * 
     * @type {string}
     * @memberof SaleTemplateAllocatedTenantsModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SaleTemplateAllocatedTenantsModel
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface SaleTemplateEditModel
 */
export interface SaleTemplateEditModel {
    /**
     * 
     * @type {Set<string>}
     * @memberof SaleTemplateEditModel
     */
    allocatedTenants?: Set<string>;
}
/**
 * 
 * @export
 * @interface SaleTemplateModel
 */
export interface SaleTemplateModel {
    /**
     * 
     * @type {string}
     * @memberof SaleTemplateModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SaleTemplateModel
     */
    name?: string;
    /**
     * 
     * @type {Array<SaleTemplateStepModel>}
     * @memberof SaleTemplateModel
     */
    steps?: Array<SaleTemplateStepModel>;
    /**
     * 
     * @type {Array<SaleTemplateAllocatedTenantsModel>}
     * @memberof SaleTemplateModel
     */
    allocatedTenants?: Array<SaleTemplateAllocatedTenantsModel>;
}
/**
 * 
 * @export
 * @interface SaleTemplateStepEditModel
 */
export interface SaleTemplateStepEditModel {
    /**
     * 
     * @type {string}
     * @memberof SaleTemplateStepEditModel
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SaleTemplateStepEditModel
     */
    planned_at?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaleTemplateStepEditModel
     */
    completed_at?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaleTemplateStepEditModel
     */
    status?: SaleTemplateStepEditModelStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SaleTemplateStepEditModel
     */
    comment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaleTemplateStepEditModel
     */
    installation_id?: string | null;
}

/**
* @export
* @enum {string}
*/
export enum SaleTemplateStepEditModelStatusEnum {
    Completed = 'completed',
    Pending = 'pending',
    Skipped = 'skipped'
}

/**
 * 
 * @export
 * @interface SaleTemplateStepModel
 */
export interface SaleTemplateStepModel {
    /**
     * 
     * @type {string}
     * @memberof SaleTemplateStepModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SaleTemplateStepModel
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SaleTemplateStepModel
     */
    cms_node_id?: string;
    /**
     * 
     * @type {string}
     * @memberof SaleTemplateStepModel
     */
    planned_at?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaleTemplateStepModel
     */
    completed_at?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaleTemplateStepModel
     */
    status?: SaleTemplateStepModelStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SaleTemplateStepModel
     */
    comment?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SaleTemplateStepModel
     */
    is_installation?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SaleTemplateStepModel
     */
    installation_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SaleTemplateStepModel
     */
    notify?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaleTemplateStepModel
     */
    is_skippable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaleTemplateStepModel
     */
    is_user_completeable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaleTemplateStepModel
     */
    is_visible?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SaleTemplateStepModel
     */
    order?: number;
}

/**
* @export
* @enum {string}
*/
export enum SaleTemplateStepModelStatusEnum {
    Completed = 'completed',
    Pending = 'pending',
    Skipped = 'skipped',
    Null = 'null'
}

/**
 * 
 * @export
 * @interface SaleTemplatesListFilter
 */
export interface SaleTemplatesListFilter {
    /**
     * 
     * @type {string}
     * @memberof SaleTemplatesListFilter
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SaleTemplatesListFilter
     */
    sale_template_id?: string;
}
/**
 * 
 * @export
 * @interface Schema
 */
export interface Schema {
    /**
     * 
     * @type {string}
     * @memberof Schema
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Schema
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Schema
     */
    versioningEnabled?: boolean;
    /**
     * 
     * @type {SchemaFields}
     * @memberof Schema
     */
    fields: SchemaFields;
}
/**
 * 
 * @export
 * @interface SchemaFields
 */
export interface SchemaFields {
    [key: string]: any | any;
    /**
     * 
     * @type {string}
     * @memberof SchemaFields
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof SchemaFields
     */
    type?: SchemaFieldsTypeEnum;
    /**
     * 
     * @type {SchemaProperties}
     * @memberof SchemaFields
     */
    properties?: SchemaProperties;
    /**
     * 
     * @type {Array<string>}
     * @memberof SchemaFields
     */
    required?: Array<string>;
}

/**
* @export
* @enum {string}
*/
export enum SchemaFieldsTypeEnum {
    String = 'string',
    Number = 'number',
    Integer = 'integer',
    Boolean = 'boolean',
    Object = 'object',
    Array = 'array',
    Null = 'null'
}

/**
 * 
 * @export
 * @interface SchemaProperties
 */
export interface SchemaProperties {
    [key: string]: any | any;
    /**
     * 
     * @type {SchemaProperty}
     * @memberof SchemaProperties
     */
    title?: SchemaProperty;
}
/**
 * 
 * @export
 * @interface SchemaProperty
 */
export interface SchemaProperty {
    /**
     * 
     * @type {string}
     * @memberof SchemaProperty
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof SchemaProperty
     */
    format?: SchemaPropertyFormatEnum;
    /**
     * 
     * @type {number}
     * @memberof SchemaProperty
     */
    sortIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof SchemaProperty
     */
    label?: string;
    /**
     * 
     * @type {object}
     * @memberof SchemaProperty
     */
    _default?: object;
    /**
     * 
     * @type {number}
     * @memberof SchemaProperty
     */
    maxLength?: number;
    /**
     * 
     * @type {number}
     * @memberof SchemaProperty
     */
    minLength?: number;
    /**
     * 
     * @type {number}
     * @memberof SchemaProperty
     */
    maximum?: number;
    /**
     * 
     * @type {number}
     * @memberof SchemaProperty
     */
    minimum?: number;
    /**
     * 
     * @type {string}
     * @memberof SchemaProperty
     */
    pattern?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SchemaProperty
     */
    _enum?: Array<string>;
    /**
     * 
     * @type {ItemFieldType}
     * @memberof SchemaProperty
     */
    items?: ItemFieldType;
    /**
     * 
     * @type {boolean}
     * @memberof SchemaProperty
     */
    uniqueItems?: boolean;
    /**
     * 
     * @type {ContainsFieldType}
     * @memberof SchemaProperty
     */
    contains?: ContainsFieldType;
    /**
     * 
     * @type {object}
     * @memberof SchemaProperty
     */
    example?: object;
}

/**
* @export
* @enum {string}
*/
export enum SchemaPropertyFormatEnum {
    String = 'string',
    Boolean = 'boolean',
    SimpleSelect = 'simple-select',
    SimpleSelectDynamic = 'simple-select-dynamic',
    MultipleSelect = 'multiple-select',
    MultipleSelectDynamic = 'multiple-select-dynamic',
    Number = 'number',
    Html = 'html',
    Date = 'date',
    Time = 'time',
    DateTime = 'date-time',
    IsoTime = 'iso-time',
    IsoDateTime = 'iso-date-time',
    Duration = 'duration',
    Uri = 'uri',
    UriReference = 'uri-reference',
    UriTemplate = 'uri-template',
    Url = 'url',
    Email = 'email',
    Hostname = 'hostname',
    Ipv4 = 'ipv4',
    Ipv6 = 'ipv6',
    Regex = 'regex',
    Uuid = 'uuid',
    JsonPointer = 'json-pointer',
    JsonPointerUriFragment = 'json-pointer-uri-fragment',
    RelativeJsonPointer = 'relative-json-pointer',
    Byte = 'byte',
    Int32 = 'int32',
    Int64 = 'int64',
    Float = 'float',
    Double = 'double',
    Password = 'password',
    Binary = 'binary'
}

/**
 * 
 * @export
 * @interface SentInvitationResponseModel
 */
export interface SentInvitationResponseModel {
    /**
     * 
     * @type {string}
     * @memberof SentInvitationResponseModel
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof SentInvitationResponseModel
     */
    moderatorUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof SentInvitationResponseModel
     */
    sentAt?: string;
    /**
     * Last event received from mailjet. Pending when no events have been received. N/A for old records that we don't have a status for
     * @type {string}
     * @memberof SentInvitationResponseModel
     */
    status?: SentInvitationResponseModelStatusEnum;
    /**
     * Time of the most recent status event update
     * @type {string}
     * @memberof SentInvitationResponseModel
     */
    modifiedOn?: string | null;
}

/**
* @export
* @enum {string}
*/
export enum SentInvitationResponseModelStatusEnum {
    Pending = 'pending',
    Open = 'open',
    Click = 'click',
    Bounce = 'bounce',
    Spam = 'spam',
    Blocked = 'blocked',
    Unsub = 'unsub',
    Sent = 'sent',
    NA = 'n/a'
}

/**
 * 
 * @export
 * @interface ServiceUnavailable
 */
export interface ServiceUnavailable {
    /**
     * The error name
     * @type {string}
     * @memberof ServiceUnavailable
     */
    name: string;
    /**
     * An error message
     * @type {string}
     * @memberof ServiceUnavailable
     */
    message: string;
    /**
     * The status code of the exception
     * @type {number}
     * @memberof ServiceUnavailable
     */
    status: number;
    /**
     * A list of related errors
     * @type {Array<GenericError>}
     * @memberof ServiceUnavailable
     */
    errors?: Array<GenericError>;
    /**
     * The stack trace (only in development mode)
     * @type {string}
     * @memberof ServiceUnavailable
     */
    stack?: string;
}
/**
 * 
 * @export
 * @interface SetReadingStartDateModel
 */
export interface SetReadingStartDateModel {
    /**
     * A new readingStartDate
     * @type {number}
     * @memberof SetReadingStartDateModel
     */
    readingStartDate: number;
}
/**
 * 
 * @export
 * @interface SiteHealthResponse
 */
export interface SiteHealthResponse {
    /**
     * 
     * @type {string}
     * @memberof SiteHealthResponse
     */
    siteId?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteHealthResponse
     */
    status?: SiteHealthResponseStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof SiteHealthResponse
     */
    statusCount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof SiteHealthResponse
     */
    statusEventTypes?: Array<string>;
    /**
     * 
     * @type {Array}
     * @memberof SiteHealthResponse
     */
    devices?: Array<any>;
}

/**
* @export
* @enum {string}
*/
export enum SiteHealthResponseStatusEnum {
    Ok = 'Ok',
    Warning = 'Warning',
    Error = 'Error',
    Missing = 'Missing'
}

/**
 * 
 * @export
 * @interface SiteHealthSummaryResponse
 */
export interface SiteHealthSummaryResponse {
    /**
     * 
     * @type {string}
     * @memberof SiteHealthSummaryResponse
     */
    customerId?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteHealthSummaryResponse
     */
    siteId?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteHealthSummaryResponse
     */
    status?: SiteHealthSummaryResponseStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof SiteHealthSummaryResponse
     */
    statusCount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof SiteHealthSummaryResponse
     */
    statusEventTypes?: Array<string>;
}

/**
* @export
* @enum {string}
*/
export enum SiteHealthSummaryResponseStatusEnum {
    Ok = 'Ok',
    Warning = 'Warning',
    Error = 'Error',
    Missing = 'Missing'
}

/**
 * 
 * @export
 * @interface SitesHealthRequestBody
 */
export interface SitesHealthRequestBody {
    /**
     * 
     * @type {Set<string>}
     * @memberof SitesHealthRequestBody
     */
    customerIds: Set<string>;
}
/**
 * 
 * @export
 * @interface SmartEnergyInstallationModel
 */
export interface SmartEnergyInstallationModel {
    /**
     * 
     * @type {number}
     * @memberof SmartEnergyInstallationModel
     */
    no?: number;
    /**
     * 
     * @type {number}
     * @memberof SmartEnergyInstallationModel
     */
    lastWeek?: number;
    /**
     * 
     * @type {SmartEnergyInstallationTypeModel}
     * @memberof SmartEnergyInstallationModel
     */
    generation?: SmartEnergyInstallationTypeModel;
    /**
     * 
     * @type {SmartEnergyInstallationTypeModel}
     * @memberof SmartEnergyInstallationModel
     */
    storage?: SmartEnergyInstallationTypeModel;
}
/**
 * 
 * @export
 * @interface SmartEnergyInstallationTypeModel
 */
export interface SmartEnergyInstallationTypeModel {
    /**
     * 
     * @type {number}
     * @memberof SmartEnergyInstallationTypeModel
     */
    value?: number;
    /**
     * 
     * @type {string}
     * @memberof SmartEnergyInstallationTypeModel
     */
    unit?: string;
}
/**
 * 
 * @export
 * @interface SmartEnergyInstallationsModel
 */
export interface SmartEnergyInstallationsModel {
    /**
     * 
     * @type {SmartEnergyInstallationModel}
     * @memberof SmartEnergyInstallationsModel
     */
    pvb?: SmartEnergyInstallationModel;
    /**
     * 
     * @type {SmartEnergyInstallationModel}
     * @memberof SmartEnergyInstallationsModel
     */
    pvonly?: SmartEnergyInstallationModel;
    /**
     * 
     * @type {SmartEnergyInstallationModel}
     * @memberof SmartEnergyInstallationsModel
     */
    pvgcp?: SmartEnergyInstallationModel;
    /**
     * 
     * @type {SmartEnergyInstallationModel}
     * @memberof SmartEnergyInstallationsModel
     */
    battery?: SmartEnergyInstallationModel;
    /**
     * 
     * @type {SmartEnergyInstallationModel}
     * @memberof SmartEnergyInstallationsModel
     */
    ev?: SmartEnergyInstallationModel;
    /**
     * 
     * @type {SmartEnergyInstallationModel}
     * @memberof SmartEnergyInstallationsModel
     */
    smarthome?: SmartEnergyInstallationModel;
    /**
     * 
     * @type {SmartEnergyInstallationModel}
     * @memberof SmartEnergyInstallationsModel
     */
    heatingcooling?: SmartEnergyInstallationModel;
    /**
     * 
     * @type {SmartEnergyInstallationModel}
     * @memberof SmartEnergyInstallationsModel
     */
    meter?: SmartEnergyInstallationModel;
    /**
     * 
     * @type {SmartEnergyInstallationModel}
     * @memberof SmartEnergyInstallationsModel
     */
    gas?: SmartEnergyInstallationModel;
    /**
     * 
     * @type {SmartEnergyInstallationModel}
     * @memberof SmartEnergyInstallationsModel
     */
    electriccar?: SmartEnergyInstallationModel;
    /**
     * 
     * @type {SmartEnergyInstallationModel}
     * @memberof SmartEnergyInstallationsModel
     */
    noConfiguration?: SmartEnergyInstallationModel;
}
/**
 * 
 * @export
 * @interface StatsVendorResponseModel
 */
export interface StatsVendorResponseModel {
    /**
     * 
     * @type {string}
     * @memberof StatsVendorResponseModel
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof StatsVendorResponseModel
     */
    display_name?: string;
    /**
     * 
     * @type {number}
     * @memberof StatsVendorResponseModel
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface SuccessMediaInfoResponseEntry
 */
export interface SuccessMediaInfoResponseEntry {
    /**
     * 
     * @type {string}
     * @memberof SuccessMediaInfoResponseEntry
     */
    status?: SuccessMediaInfoResponseEntryStatusEnum;
    /**
     * 
     * @type {MediaInfo}
     * @memberof SuccessMediaInfoResponseEntry
     */
    data?: MediaInfo;
}

/**
* @export
* @enum {string}
*/
export enum SuccessMediaInfoResponseEntryStatusEnum {
    Success = 'success'
}

/**
 * 
 * @export
 * @interface SummaryModel
 */
export interface SummaryModel {
    /**
     * 
     * @type {number}
     * @memberof SummaryModel
     */
    consumption?: number;
    /**
     * 
     * @type {number}
     * @memberof SummaryModel
     */
    production?: number;
}
/**
 * 
 * @export
 * @interface SystemHealthModel
 */
export interface SystemHealthModel {
    /**
     * 
     * @type {string}
     * @memberof SystemHealthModel
     */
    status?: SystemHealthModelStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum SystemHealthModelStatusEnum {
    Available = 'available',
    Unavailable = 'unavailable',
    Degraded = 'degraded'
}

/**
 * 
 * @export
 * @interface TechnicalCustomerAddModel
 */
export interface TechnicalCustomerAddModel {
    /**
     * 
     * @type {string}
     * @memberof TechnicalCustomerAddModel
     */
    customer_type: TechnicalCustomerAddModelCustomerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TechnicalCustomerAddModel
     */
    account_name: string;
    /**
     * 
     * @type {NameModel}
     * @memberof TechnicalCustomerAddModel
     */
    name: NameModel;
    /**
     * 
     * @type {string}
     * @memberof TechnicalCustomerAddModel
     */
    username: string;
    /**
     * Post code specific to the selected country
     * @type {string}
     * @memberof TechnicalCustomerAddModel
     */
    zip_code: string;
    /**
     * 
     * @type {string}
     * @memberof TechnicalCustomerAddModel
     */
    country: TechnicalCustomerAddModelCountryEnum;
    /**
     * Reference of an external source [Optional]
     * @type {string}
     * @memberof TechnicalCustomerAddModel
     */
    ext_reference: string;
    /**
     * Additional reference of an external source [Optional]
     * @type {string}
     * @memberof TechnicalCustomerAddModel
     */
    ext_reference_1: string;
    /**
     * 
     * @type {string}
     * @memberof TechnicalCustomerAddModel
     */
    site_name?: string;
    /**
     * 
     * @type {string}
     * @memberof TechnicalCustomerAddModel
     */
    city?: string;
    /**
     * Optional. Otherwise is sub-account of the root account
     * @type {string}
     * @memberof TechnicalCustomerAddModel
     */
    tenant_id?: string;
    /**
     * Source of the customer import [Optional]
     * @type {string}
     * @memberof TechnicalCustomerAddModel
     */
    ext_source?: string;
    /**
     * IDP Provider [Optional]
     * @type {string}
     * @memberof TechnicalCustomerAddModel
     */
    idp_provider?: string;
}

/**
* @export
* @enum {string}
*/
export enum TechnicalCustomerAddModelCustomerTypeEnum {
    ResidentialCustomer = 'residential_customer',
    Partner = 'partner',
    WhitelabelPartner = 'whitelabel_partner'
}
/**
* @export
* @enum {string}
*/
export enum TechnicalCustomerAddModelCountryEnum {
    EnGb = 'en_GB',
    DeDe = 'de_DE',
    SvSe = 'sv_SE',
    ItIt = 'it_IT',
    PlPl = 'pl_PL',
    HuHu = 'hu_HU',
    CsCz = 'cs_CZ',
    HrHr = 'hr_HR',
    EnUk = 'en_UK',
    NlNl = 'nl_NL'
}

/**
 * 
 * @export
 * @interface TenantAffiliateAddModel
 */
export interface TenantAffiliateAddModel {
    /**
     * 
     * @type {string}
     * @memberof TenantAffiliateAddModel
     */
    country: TenantAffiliateAddModelCountryEnum;
    /**
     * 
     * @type {string}
     * @memberof TenantAffiliateAddModel
     */
    domain: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAffiliateAddModel
     */
    tenantId: string;
    /**
     * 
     * @type {boolean}
     * @memberof TenantAffiliateAddModel
     */
    openRegistration: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantAffiliateAddModel
     */
    emailContact: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAffiliateAddModel
     */
    phoneContact?: string;
    /**
     * 
     * @type {TenantAffiliateResponseModelSupportedLanguages}
     * @memberof TenantAffiliateAddModel
     */
    supportedLanguages: TenantAffiliateResponseModelSupportedLanguages;
    /**
     * 
     * @type {string}
     * @memberof TenantAffiliateAddModel
     */
    emailActivation: string;
    /**
     * 
     * @type {boolean}
     * @memberof TenantAffiliateAddModel
     */
    pvSelfOnboarding: boolean;
    /**
     * 
     * @type {TenantAffiliateResponseModelPvContact}
     * @memberof TenantAffiliateAddModel
     */
    pvSelfOnboardingContact: TenantAffiliateResponseModelPvContact;
    /**
     * 
     * @type {string}
     * @memberof TenantAffiliateAddModel
     */
    impressumUrl: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAffiliateAddModel
     */
    pvSelfOnboardingInstallEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAffiliateAddModel
     */
    qualtricsUrlWeb?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantAffiliateAddModel
     */
    qualtricsUrlMobile?: string | null;
    /**
     * 
     * @type {Array}
     * @memberof TenantAffiliateAddModel
     */
    saleJourneys?: Array<any>;
}

/**
* @export
* @enum {string}
*/
export enum TenantAffiliateAddModelCountryEnum {
    Gb = 'GB',
    De = 'DE',
    It = 'IT',
    Se = 'SE',
    Hu = 'HU',
    Pl = 'PL',
    Al = 'AL',
    Cz = 'CZ',
    Hr = 'HR'
}

/**
 * 
 * @export
 * @interface TenantAffiliateFilterModel
 */
export interface TenantAffiliateFilterModel {
    /**
     * 
     * @type {number}
     * @memberof TenantAffiliateFilterModel
     */
    _id?: number;
    /**
     * 
     * @type {string}
     * @memberof TenantAffiliateFilterModel
     */
    domain?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TenantAffiliateFilterModel
     */
    isMobile?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantAffiliateFilterModel
     */
    includeSubTenants?: boolean;
}
/**
 * 
 * @export
 * @interface TenantAffiliateResponseModel
 */
export interface TenantAffiliateResponseModel {
    /**
     * 
     * @type {string}
     * @memberof TenantAffiliateResponseModel
     */
    country: TenantAffiliateResponseModelCountryEnum;
    /**
     * 
     * @type {string}
     * @memberof TenantAffiliateResponseModel
     */
    domain: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAffiliateResponseModel
     */
    tenantId: string;
    /**
     * 
     * @type {boolean}
     * @memberof TenantAffiliateResponseModel
     */
    openRegistration: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantAffiliateResponseModel
     */
    emailContact: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAffiliateResponseModel
     */
    phoneContact?: string;
    /**
     * 
     * @type {TenantAffiliateResponseModelSupportedLanguages}
     * @memberof TenantAffiliateResponseModel
     */
    supportedLanguages: TenantAffiliateResponseModelSupportedLanguages;
    /**
     * 
     * @type {string}
     * @memberof TenantAffiliateResponseModel
     */
    emailActivation: string;
    /**
     * 
     * @type {boolean}
     * @memberof TenantAffiliateResponseModel
     */
    pvSelfOnboarding: boolean;
    /**
     * 
     * @type {TenantAffiliateResponseModelPvContact}
     * @memberof TenantAffiliateResponseModel
     */
    pvSelfOnboardingContact: TenantAffiliateResponseModelPvContact;
    /**
     * 
     * @type {string}
     * @memberof TenantAffiliateResponseModel
     */
    impressumUrl: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAffiliateResponseModel
     */
    pvSelfOnboardingInstallEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAffiliateResponseModel
     */
    qualtricsUrlWeb?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantAffiliateResponseModel
     */
    qualtricsUrlMobile?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantAffiliateResponseModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAffiliateResponseModel
     */
    tenantName?: string;
    /**
     * 
     * @type {Array}
     * @memberof TenantAffiliateResponseModel
     */
    saleJourneys?: Array<any>;
    /**
     * 
     * @type {Array<TenantAffiliateSubTenant>}
     * @memberof TenantAffiliateResponseModel
     */
    subTenants?: Array<TenantAffiliateSubTenant>;
}

/**
* @export
* @enum {string}
*/
export enum TenantAffiliateResponseModelCountryEnum {
    Gb = 'GB',
    De = 'DE',
    It = 'IT',
    Se = 'SE',
    Hu = 'HU',
    Pl = 'PL',
    Al = 'AL',
    Cz = 'CZ',
    Hr = 'HR'
}

/**
 * 
 * @export
 * @interface TenantAffiliateResponseModelPvContact
 */
export interface TenantAffiliateResponseModelPvContact {
    /**
     * 
     * @type {string}
     * @memberof TenantAffiliateResponseModelPvContact
     */
    email?: string;
    /**
     * 
     * @type {TenantAffiliateResponseModelPvContactPhone}
     * @memberof TenantAffiliateResponseModelPvContact
     */
    phone?: TenantAffiliateResponseModelPvContactPhone;
}
/**
 * 
 * @export
 * @interface TenantAffiliateResponseModelPvContactPhone
 */
export interface TenantAffiliateResponseModelPvContactPhone {
    /**
     * 
     * @type {string}
     * @memberof TenantAffiliateResponseModelPvContactPhone
     */
    raw?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAffiliateResponseModelPvContactPhone
     */
    prettified?: string;
}
/**
 * 
 * @export
 * @interface TenantAffiliateResponseModelSupportedLanguages
 */
export interface TenantAffiliateResponseModelSupportedLanguages {
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantAffiliateResponseModelSupportedLanguages
     */
    languages?: Array<string>;
}
/**
 * 
 * @export
 * @interface TenantAffiliateSubTenant
 */
export interface TenantAffiliateSubTenant {
    /**
     * 
     * @type {string}
     * @memberof TenantAffiliateSubTenant
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAffiliateSubTenant
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TenantAffiliateSubTenant
     */
    isWhitelabelPartner?: boolean;
}
/**
 * 
 * @export
 * @interface TenantAllocationsFilterModel
 */
export interface TenantAllocationsFilterModel {
    /**
     * Name of the tenant
     * @type {string}
     * @memberof TenantAllocationsFilterModel
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface TenantAllocationsResponseModel
 */
export interface TenantAllocationsResponseModel {
    /**
     * 
     * @type {string}
     * @memberof TenantAllocationsResponseModel
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAllocationsResponseModel
     */
    tenantName?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAllocationsResponseModel
     */
    vendorId?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAllocationsResponseModel
     */
    vendorName?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAllocationsResponseModel
     */
    vendorReferenceId: string;
}
/**
 * 
 * @export
 * @interface TooManyRequests
 */
export interface TooManyRequests {
    /**
     * The error name
     * @type {string}
     * @memberof TooManyRequests
     */
    name: string;
    /**
     * An error message
     * @type {string}
     * @memberof TooManyRequests
     */
    message: string;
    /**
     * The status code of the exception
     * @type {number}
     * @memberof TooManyRequests
     */
    status: number;
    /**
     * A list of related errors
     * @type {Array<GenericError>}
     * @memberof TooManyRequests
     */
    errors?: Array<GenericError>;
    /**
     * The stack trace (only in development mode)
     * @type {string}
     * @memberof TooManyRequests
     */
    stack?: string;
}
/**
 * 
 * @export
 * @interface UnallocatedDeviceResponseModel
 */
export interface UnallocatedDeviceResponseModel {
    /**
     * 
     * @type {string}
     * @memberof UnallocatedDeviceResponseModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedDeviceResponseModel
     */
    deviceType?: string;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedDeviceResponseModel
     */
    deviceId?: string;
    /**
     * 
     * @type {UnallocatedDeviceResponseModelDeviceConfiguration}
     * @memberof UnallocatedDeviceResponseModel
     */
    deviceConfiguration?: UnallocatedDeviceResponseModelDeviceConfiguration;
    /**
     * 
     * @type {DeviceGateway}
     * @memberof UnallocatedDeviceResponseModel
     */
    deviceGateway?: DeviceGateway;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedDeviceResponseModel
     */
    vendorName?: string;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedDeviceResponseModel
     */
    timezone?: string;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedDeviceResponseModel
     */
    creationTime?: string;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedDeviceResponseModel
     */
    modifiedTime?: string;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedDeviceResponseModel
     */
    installerId?: string;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedDeviceResponseModel
     */
    installationId?: string;
    /**
     * 
     * @type {InstallationOpt}
     * @memberof UnallocatedDeviceResponseModel
     */
    installationOpt?: InstallationOpt;
    /**
     * 
     * @type {GridXAppliance}
     * @memberof UnallocatedDeviceResponseModel
     */
    gridXAppliance?: GridXAppliance;
}
/**
 * @type UnallocatedDeviceResponseModelDeviceConfiguration
 * 
 * @export
 */
export type UnallocatedDeviceResponseModelDeviceConfiguration = EVDeviceConfiguration | GatewayDeviceConfiguration | HeatPumpDeviceConfigurationModel | MeterDeviceConfiguration | PVDeviceConfiguration;
/**
 * 
 * @export
 * @interface UnallocatedGatewayInstallationRequestModel
 */
export interface UnallocatedGatewayInstallationRequestModel {
    /**
     * 
     * @type {string}
     * @memberof UnallocatedGatewayInstallationRequestModel
     */
    deviceType: UnallocatedGatewayInstallationRequestModelDeviceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedGatewayInstallationRequestModel
     */
    manufacturer: string;
    /**
     * 
     * @type {VendorModel}
     * @memberof UnallocatedGatewayInstallationRequestModel
     */
    vendor: VendorModel;
}

/**
* @export
* @enum {string}
*/
export enum UnallocatedGatewayInstallationRequestModelDeviceTypeEnum {
    Inverter = 'Inverter',
    Ev = 'EV',
    Heatpump = 'Heatpump',
    Sphere = 'Sphere',
    Gateway = 'Gateway',
    Smarthome = 'smarthome',
    Meter = 'Meter',
    Gas = 'Gas',
    ElectricCar = 'ElectricCar',
    HeatPump = 'HEAT_PUMP'
}

/**
 * 
 * @export
 * @interface UnallocatedGatewayResponseModel
 */
export interface UnallocatedGatewayResponseModel {
    /**
     * 
     * @type {string}
     * @memberof UnallocatedGatewayResponseModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedGatewayResponseModel
     */
    deviceType?: string;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedGatewayResponseModel
     */
    deviceId?: string;
    /**
     * 
     * @type {UnallocatedGatewayResponseModelDeviceConfiguration}
     * @memberof UnallocatedGatewayResponseModel
     */
    deviceConfiguration?: UnallocatedGatewayResponseModelDeviceConfiguration;
    /**
     * 
     * @type {DeviceGateway}
     * @memberof UnallocatedGatewayResponseModel
     */
    deviceGateway?: DeviceGateway;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedGatewayResponseModel
     */
    vendorName?: string;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedGatewayResponseModel
     */
    timezone?: string;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedGatewayResponseModel
     */
    creationTime?: string;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedGatewayResponseModel
     */
    modifiedTime?: string;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedGatewayResponseModel
     */
    installerId?: string;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedGatewayResponseModel
     */
    installationId?: string;
    /**
     * 
     * @type {InstallationOpt}
     * @memberof UnallocatedGatewayResponseModel
     */
    installationOpt?: InstallationOpt;
    /**
     * 
     * @type {GridXAppliance}
     * @memberof UnallocatedGatewayResponseModel
     */
    gridXAppliance?: GridXAppliance;
}
/**
 * @type UnallocatedGatewayResponseModelDeviceConfiguration
 * 
 * @export
 */
export type UnallocatedGatewayResponseModelDeviceConfiguration = EVDeviceConfiguration | GatewayDeviceConfiguration | HeatPumpDeviceConfigurationModel | MeterDeviceConfiguration | PVDeviceConfiguration;
/**
 * 
 * @export
 * @interface UnallocatedInstallationDeviceUpdateModel
 */
export interface UnallocatedInstallationDeviceUpdateModel {
    /**
     * 
     * @type {string}
     * @memberof UnallocatedInstallationDeviceUpdateModel
     */
    deviceType: UnallocatedInstallationDeviceUpdateModelDeviceTypeEnum;
    /**
     * 
     * @type {UnallocatedInstallationDeviceUpdateModelData}
     * @memberof UnallocatedInstallationDeviceUpdateModel
     */
    data: UnallocatedInstallationDeviceUpdateModelData;
}

/**
* @export
* @enum {string}
*/
export enum UnallocatedInstallationDeviceUpdateModelDeviceTypeEnum {
    Inverter = 'Inverter',
    Ev = 'EV',
    Heatpump = 'Heatpump',
    Sphere = 'Sphere',
    Gateway = 'Gateway',
    Smarthome = 'smarthome',
    Meter = 'Meter',
    Gas = 'Gas',
    ElectricCar = 'ElectricCar',
    HeatPump = 'HEAT_PUMP'
}

/**
 * 
 * @export
 * @interface UnallocatedInstallationDeviceUpdateModelData
 */
export interface UnallocatedInstallationDeviceUpdateModelData {
    /**
     * 
     * @type {BatteryModel}
     * @memberof UnallocatedInstallationDeviceUpdateModelData
     */
    battery?: BatteryModel;
    /**
     * 
     * @type {InverterModel}
     * @memberof UnallocatedInstallationDeviceUpdateModelData
     */
    inverter?: InverterModel;
    /**
     * 
     * @type {Array<PvPanel>}
     * @memberof UnallocatedInstallationDeviceUpdateModelData
     */
    panels?: Array<PvPanel>;
    /**
     * 
     * @type {VendorModel}
     * @memberof UnallocatedInstallationDeviceUpdateModelData
     */
    vendor?: VendorModel;
    /**
     * Add products attached to this installation such as SolarCloud [Optional]
     * @type {Array<ProductModel>}
     * @memberof UnallocatedInstallationDeviceUpdateModelData
     */
    products?: Array<ProductModel>;
    /**
     * The date of the installation as isodate
     * @type {string}
     * @memberof UnallocatedInstallationDeviceUpdateModelData
     */
    installationDate?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnallocatedInstallationDeviceUpdateModelData
     */
    onlyPeakPowerUpdate?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedInstallationDeviceUpdateModelData
     */
    kind?: UnallocatedInstallationDeviceUpdateModelDataKindEnum;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedInstallationDeviceUpdateModelData
     */
    stationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedInstallationDeviceUpdateModelData
     */
    manufacturer?: string;
    /**
     * 
     * @type {number}
     * @memberof UnallocatedInstallationDeviceUpdateModelData
     */
    powerOutput?: number;
    /**
     * 
     * @type {number}
     * @memberof UnallocatedInstallationDeviceUpdateModelData
     */
    modulationMinimalLevel?: number;
    /**
     * 
     * @type {number}
     * @memberof UnallocatedInstallationDeviceUpdateModelData
     */
    connectorId?: number;
}

/**
* @export
* @enum {string}
*/
export enum UnallocatedInstallationDeviceUpdateModelDataKindEnum {
    Unknown = 'UNKNOWN',
    Pv = 'PV',
    PvExternal = 'PV_EXTERNAL',
    Battery = 'BATTERY',
    Hybrid = 'HYBRID',
    Grid = 'GRID',
    HeatPump = 'HEAT_PUMP',
    FuelCell = 'FUEL_CELL',
    HeatPumpExternal = 'HEAT_PUMP_EXTERNAL',
    Evstation = 'EVSTATION',
    Bttp = 'BTTP',
    Heating = 'HEATING',
    Misc = 'MISC',
    Cluster = 'CLUSTER',
    WindTurbine = 'WIND_TURBINE'
}

/**
 * 
 * @export
 * @interface UnallocatedInstallationsResponseModel
 */
export interface UnallocatedInstallationsResponseModel {
    /**
     * 
     * @type {number}
     * @memberof UnallocatedInstallationsResponseModel
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof UnallocatedInstallationsResponseModel
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof UnallocatedInstallationsResponseModel
     */
    limit: number;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedInstallationsResponseModel
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedInstallationsResponseModel
     */
    installerId?: string;
    /**
     * 
     * @type {Array<UnallocatedTenantGatewayResponseModel>}
     * @memberof UnallocatedInstallationsResponseModel
     */
    list: Array<UnallocatedTenantGatewayResponseModel>;
}
/**
 * 
 * @export
 * @interface UnallocatedMeterUpdateRequestModel
 */
export interface UnallocatedMeterUpdateRequestModel {
    /**
     * 
     * @type {string}
     * @memberof UnallocatedMeterUpdateRequestModel
     */
    kind?: UnallocatedMeterUpdateRequestModelKindEnum;
}

/**
* @export
* @enum {string}
*/
export enum UnallocatedMeterUpdateRequestModelKindEnum {
    Unknown = 'UNKNOWN',
    Pv = 'PV',
    PvExternal = 'PV_EXTERNAL',
    Battery = 'BATTERY',
    Hybrid = 'HYBRID',
    Grid = 'GRID',
    HeatPump = 'HEAT_PUMP',
    FuelCell = 'FUEL_CELL',
    HeatPumpExternal = 'HEAT_PUMP_EXTERNAL',
    Evstation = 'EVSTATION',
    Bttp = 'BTTP',
    Heating = 'HEATING',
    Misc = 'MISC',
    Cluster = 'CLUSTER',
    WindTurbine = 'WIND_TURBINE'
}

/**
 * 
 * @export
 * @interface UnallocatedTenantGatewayResponseModel
 */
export interface UnallocatedTenantGatewayResponseModel {
    /**
     * 
     * @type {string}
     * @memberof UnallocatedTenantGatewayResponseModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedTenantGatewayResponseModel
     */
    deviceType?: string;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedTenantGatewayResponseModel
     */
    deviceId?: string;
    /**
     * 
     * @type {UnallocatedGatewayResponseModelDeviceConfiguration}
     * @memberof UnallocatedTenantGatewayResponseModel
     */
    deviceConfiguration?: UnallocatedGatewayResponseModelDeviceConfiguration;
    /**
     * 
     * @type {DeviceGateway}
     * @memberof UnallocatedTenantGatewayResponseModel
     */
    deviceGateway?: DeviceGateway;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedTenantGatewayResponseModel
     */
    vendorName?: string;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedTenantGatewayResponseModel
     */
    timezone?: string;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedTenantGatewayResponseModel
     */
    creationTime?: string;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedTenantGatewayResponseModel
     */
    modifiedTime?: string;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedTenantGatewayResponseModel
     */
    installerId?: string;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedTenantGatewayResponseModel
     */
    installationId?: string;
    /**
     * 
     * @type {InstallationOpt}
     * @memberof UnallocatedTenantGatewayResponseModel
     */
    installationOpt?: InstallationOpt;
    /**
     * 
     * @type {GridXAppliance}
     * @memberof UnallocatedTenantGatewayResponseModel
     */
    gridXAppliance?: GridXAppliance;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedTenantGatewayResponseModel
     */
    vendorId?: string;
}
/**
 * 
 * @export
 * @interface UnallocatedWallboxRequestModel
 */
export interface UnallocatedWallboxRequestModel {
    /**
     * 
     * @type {string}
     * @memberof UnallocatedWallboxRequestModel
     */
    stationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UnallocatedWallboxRequestModel
     */
    manufacturer?: string;
    /**
     * 
     * @type {number}
     * @memberof UnallocatedWallboxRequestModel
     */
    powerOutput?: number;
    /**
     * 
     * @type {number}
     * @memberof UnallocatedWallboxRequestModel
     */
    modulationMinimalLevel?: number;
    /**
     * 
     * @type {number}
     * @memberof UnallocatedWallboxRequestModel
     */
    connectorId?: number;
}
/**
 * 
 * @export
 * @interface Unauthorized
 */
export interface Unauthorized {
    /**
     * The error name
     * @type {string}
     * @memberof Unauthorized
     */
    name: string;
    /**
     * An error message
     * @type {string}
     * @memberof Unauthorized
     */
    message: string;
    /**
     * The status code of the exception
     * @type {number}
     * @memberof Unauthorized
     */
    status: number;
    /**
     * A list of related errors
     * @type {Array<GenericError>}
     * @memberof Unauthorized
     */
    errors?: Array<GenericError>;
    /**
     * The stack trace (only in development mode)
     * @type {string}
     * @memberof Unauthorized
     */
    stack?: string;
}
/**
 * 
 * @export
 * @interface UpdateContentRequest
 */
export interface UpdateContentRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateContentRequest
     */
    state: UpdateContentRequestStateEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateContentRequest
     */
    order?: number;
    /**
     * 
     * @type {ContentFields}
     * @memberof UpdateContentRequest
     */
    fields?: ContentFields;
}

/**
* @export
* @enum {string}
*/
export enum UpdateContentRequestStateEnum {
    Draft = 'draft',
    Published = 'published',
    Freeze = 'freeze'
}

/**
 * 
 * @export
 * @interface UriResponseModel
 */
export interface UriResponseModel {
    /**
     * 
     * @type {string}
     * @memberof UriResponseModel
     */
    uri?: string;
}
/**
 * 
 * @export
 * @interface UserReactivationModel
 */
export interface UserReactivationModel {
    /**
     * The user reactivation outcome. ReacticationAvailable for 30 days.
     * @type {boolean}
     * @memberof UserReactivationModel
     */
    reactivated: boolean;
}
/**
 * 
 * @export
 * @interface V2CustomerAddModel
 */
export interface V2CustomerAddModel {
    /**
     * 
     * @type {NameModel}
     * @memberof V2CustomerAddModel
     */
    name: NameModel;
    /**
     * 
     * @type {string}
     * @memberof V2CustomerAddModel
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof V2CustomerAddModel
     */
    country: V2CustomerAddModelCountryEnum;
    /**
     * Post code specific to the selected country
     * @type {string}
     * @memberof V2CustomerAddModel
     */
    zip_code: string;
    /**
     * Reference of an external source
     * @type {string}
     * @memberof V2CustomerAddModel
     */
    ext_reference: string;
    /**
     * Otherwise basic subscription is taken [Optional]
     * @type {Array<any>}
     * @memberof V2CustomerAddModel
     */
    feature_groups_list?: Array<any>;
    /**
     * Additional reference of an external source [Optional]
     * @type {string}
     * @memberof V2CustomerAddModel
     */
    ext_reference_1?: string;
    /**
     * IDP Provider [Optional]
     * @type {string}
     * @memberof V2CustomerAddModel
     */
    idp_provider?: string;
    /**
     * 
     * @type {boolean}
     * @memberof V2CustomerAddModel
     */
    preInstallationGridXOnly?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum V2CustomerAddModelCountryEnum {
    EnGb = 'en_GB',
    DeDe = 'de_DE',
    SvSe = 'sv_SE',
    ItIt = 'it_IT',
    HuHu = 'hu_HU',
    PlPl = 'pl_PL',
    CsCz = 'cs_CZ',
    EnUk = 'en_UK',
    NlNl = 'nl_NL'
}

/**
 * 
 * @export
 * @interface VendorAllocationPatchModel
 */
export interface VendorAllocationPatchModel {
    /**
     * 
     * @type {string}
     * @memberof VendorAllocationPatchModel
     */
    vendorReferenceId: string;
}
/**
 * 
 * @export
 * @interface VendorAllocationPostModel
 */
export interface VendorAllocationPostModel {
    /**
     * 
     * @type {string}
     * @memberof VendorAllocationPostModel
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof VendorAllocationPostModel
     */
    display_name: string;
    /**
     * 
     * @type {string}
     * @memberof VendorAllocationPostModel
     */
    category: VendorAllocationPostModelCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof VendorAllocationPostModel
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof VendorAllocationPostModel
     */
    secret?: string;
    /**
     * Vendor associated color HEX
     * @type {string}
     * @memberof VendorAllocationPostModel
     */
    color?: string;
    /**
     * Required fields
     * @type {Array}
     * @memberof VendorAllocationPostModel
     */
    vendor_fields?: Array<any>;
    /**
     * 
     * @type {string}
     * @memberof VendorAllocationPostModel
     */
    vendorReferenceId: string;
}

/**
* @export
* @enum {string}
*/
export enum VendorAllocationPostModelCategoryEnum {
    Ev = 'ev',
    Pvbattery = 'pvbattery',
    Iothub = 'iothub',
    Meter = 'meter'
}

/**
 * 
 * @export
 * @interface VendorApiKeySetModel
 */
export interface VendorApiKeySetModel {
    /**
     * 
     * @type {string}
     * @memberof VendorApiKeySetModel
     */
    apiKeyName?: VendorApiKeySetModelApiKeyNameEnum;
    /**
     * 
     * @type {string}
     * @memberof VendorApiKeySetModel
     */
    apiKeyValue?: string;
}

/**
* @export
* @enum {string}
*/
export enum VendorApiKeySetModelApiKeyNameEnum {
    NordicInstallationidConsumed = 'nordic-installationid-consumed',
    NordicInstallationidProduced = 'nordic-installationid-produced',
    EoiSmvVrmportalid1 = 'eoi_smv_vrmportalid1',
    EoiSmsApikey = 'eoi_sms_apikey',
    EoiSmvInstallationid1 = 'eoi_smv_installationid1',
    EoiSmsSiteid = 'eoi_sms_siteid',
    UserId = 'userId',
    DeviceId = 'device_id',
    LoggerSn = 'logger_sn',
    PlantId = 'plant_id',
    StartCode = 'start_code',
    GatewayId = 'gateway_id',
    ApplianceId = 'appliance_id'
}

/**
 * 
 * @export
 * @interface VendorModel
 */
export interface VendorModel {
    /**
     * 
     * @type {string}
     * @memberof VendorModel
     */
    name?: string;
    /**
     * 
     * @type {Array<VendorApiKeySetModel>}
     * @memberof VendorModel
     */
    apiKeys?: Array<VendorApiKeySetModel>;
    /**
     * 
     * @type {string}
     * @memberof VendorModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof VendorModel
     */
    vendorReferenceId?: string;
}
/**
 * 
 * @export
 * @interface VendorSubModel
 */
export interface VendorSubModel {
    /**
     * 
     * @type {string}
     * @memberof VendorSubModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof VendorSubModel
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof VendorSubModel
     */
    display_name?: string;
}
/**
 * 
 * @export
 * @interface WallboxInstallationRequestModel
 */
export interface WallboxInstallationRequestModel {
    /**
     * 
     * @type {VendorModel}
     * @memberof WallboxInstallationRequestModel
     */
    vendor?: VendorModel;
    /**
     * 
     * @type {string}
     * @memberof WallboxInstallationRequestModel
     */
    stationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof WallboxInstallationRequestModel
     */
    manufacturer?: string;
    /**
     * 
     * @type {number}
     * @memberof WallboxInstallationRequestModel
     */
    powerOutput?: number;
    /**
     * 
     * @type {number}
     * @memberof WallboxInstallationRequestModel
     */
    modulationMinimalLevel?: number;
    /**
     * 
     * @type {number}
     * @memberof WallboxInstallationRequestModel
     */
    connectorId?: number;
}
/**
 * 
 * @export
 * @interface WallboxModel
 */
export interface WallboxModel {
    /**
     * 
     * @type {string}
     * @memberof WallboxModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WallboxModel
     */
    deviceType?: string;
    /**
     * 
     * @type {string}
     * @memberof WallboxModel
     */
    deviceId?: string;
    /**
     * 
     * @type {EVDeviceConfiguration}
     * @memberof WallboxModel
     */
    deviceConfiguration?: EVDeviceConfiguration;
    /**
     * 
     * @type {DeviceGateway}
     * @memberof WallboxModel
     */
    deviceGateway?: DeviceGateway;
    /**
     * 
     * @type {string}
     * @memberof WallboxModel
     */
    vendorName?: string;
}
/**
 * 
 * @export
 * @interface WallboxModelResponseModel
 */
export interface WallboxModelResponseModel {
    /**
     * 
     * @type {string}
     * @memberof WallboxModelResponseModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WallboxModelResponseModel
     */
    deviceType?: string;
    /**
     * 
     * @type {string}
     * @memberof WallboxModelResponseModel
     */
    deviceId?: string;
    /**
     * 
     * @type {EVDeviceConfiguration}
     * @memberof WallboxModelResponseModel
     */
    deviceConfiguration?: EVDeviceConfiguration;
    /**
     * 
     * @type {DeviceGateway}
     * @memberof WallboxModelResponseModel
     */
    deviceGateway?: DeviceGateway;
    /**
     * 
     * @type {string}
     * @memberof WallboxModelResponseModel
     */
    vendorName?: string;
    /**
     * 
     * @type {string}
     * @memberof WallboxModelResponseModel
     */
    createdOn?: string;
    /**
     * 
     * @type {string}
     * @memberof WallboxModelResponseModel
     */
    lastModified?: string;
}
/**
 * 
 * @export
 * @interface WhitelabelConfigurationModel
 */
export interface WhitelabelConfigurationModel {
    /**
     * 
     * @type {string}
     * @memberof WhitelabelConfigurationModel
     */
    application_name?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelConfigurationModel
     */
    modified_on?: string;
    /**
     * 
     * @type {number}
     * @memberof WhitelabelConfigurationModel
     */
    domain_id?: number;
    /**
     * 
     * @type {number}
     * @memberof WhitelabelConfigurationModel
     */
    hosting_id?: number;
    /**
     * 
     * @type {number}
     * @memberof WhitelabelConfigurationModel
     */
    idp_id?: number;
    /**
     * 
     * @type {number}
     * @memberof WhitelabelConfigurationModel
     */
    brand_appearance_id?: number;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelConfigurationModel
     */
    status?: WhitelabelConfigurationModelStatusEnum;
    /**
     * 
     * @type {Array<WhitelabelResource>}
     * @memberof WhitelabelConfigurationModel
     */
    activeResources?: Array<WhitelabelResource>;
}

/**
* @export
* @enum {string}
*/
export enum WhitelabelConfigurationModelStatusEnum {
    CreateComplete = 'CREATE_COMPLETE',
    CreateInProgress = 'CREATE_IN_PROGRESS',
    CreateFailed = 'CREATE_FAILED',
    DeleteComplete = 'DELETE_COMPLETE',
    DeleteInProgress = 'DELETE_IN_PROGRESS',
    UpdateComplete = 'UPDATE_COMPLETE',
    UpdateInProgress = 'UPDATE_IN_PROGRESS'
}

/**
 * 
 * @export
 * @interface WhitelabelResource
 */
export interface WhitelabelResource {
    /**
     * 
     * @type {number}
     * @memberof WhitelabelResource
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelResource
     */
    type?: WhitelabelResourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelResource
     */
    modified_on?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelResource
     */
    status?: WhitelabelResourceStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum WhitelabelResourceTypeEnum {
    Domain = 'domain',
    Idp = 'idp',
    Hosting = 'hosting',
    Email = 'email'
}
/**
* @export
* @enum {string}
*/
export enum WhitelabelResourceStatusEnum {
    CreateComplete = 'CREATE_COMPLETE',
    CreateInProgress = 'CREATE_IN_PROGRESS',
    CreateFailed = 'CREATE_FAILED',
    DeleteComplete = 'DELETE_COMPLETE',
    DeleteInProgress = 'DELETE_IN_PROGRESS',
    UpdateComplete = 'UPDATE_COMPLETE',
    UpdateInProgress = 'UPDATE_IN_PROGRESS'
}

/**
 * 
 * @export
 * @interface WorkItemModel
 */
export interface WorkItemModel {
    /**
     * The Id of the received site
     * @type {string}
     * @memberof WorkItemModel
     */
    siteId: string;
    /**
     * The current actin for the given Item
     * @type {string}
     * @memberof WorkItemModel
     */
    action: WorkItemModelActionEnum;
    /**
     * 
     * @type {number}
     * @memberof WorkItemModel
     */
    numberOfDaysGivenUp: number;
    /**
     * 
     * @type {string}
     * @memberof WorkItemModel
     */
    creationTime: string;
    /**
     * The Id of the configured site
     * @type {string}
     * @memberof WorkItemModel
     */
    configId: string;
    /**
     * The amount of days without any data for this work item
     * @type {number}
     * @memberof WorkItemModel
     */
    consecutiveDaysOfNoData: number;
    /**
     * 
     * @type {string}
     * @memberof WorkItemModel
     */
    importStartDate: string;
    /**
     * 
     * @type {string}
     * @memberof WorkItemModel
     */
    importDatePointer: string;
    /**
     * 
     * @type {string}
     * @memberof WorkItemModel
     */
    importHeartbeat: string;
    /**
     * The start Date of this import
     * @type {number}
     * @memberof WorkItemModel
     */
    importReadingStartDate: number;
    /**
     * An Enum of the current Status of this WorkItem
     * @type {string}
     * @memberof WorkItemModel
     */
    status: WorkItemModelStatusEnum;
    /**
     * The vendor for this given Work Item
     * @type {string}
     * @memberof WorkItemModel
     */
    vendor: string;
    /**
     * The current Version of this Import Work Item
     * @type {string}
     * @memberof WorkItemModel
     */
    version: string;
    /**
     * The start date of the previous Import
     * @type {number}
     * @memberof WorkItemModel
     */
    previousImportReadingStartDate: number;
    /**
     * The End Date of this given Work Item
     * @type {string}
     * @memberof WorkItemModel
     */
    importEndDate: string;
    /**
     * The Errors of this given work Item
     * @type {object}
     * @memberof WorkItemModel
     */
    importErrors: object;
    /**
     * The given ID of this WorkItem
     * @type {string}
     * @memberof WorkItemModel
     */
    id: string;
}

/**
* @export
* @enum {string}
*/
export enum WorkItemModelActionEnum {
    Reimport = 'reimport',
    ExtendHistoricalData = 'extendHistoricalData',
    SpecificTimeFrame = 'specificTimeFrame'
}
/**
* @export
* @enum {string}
*/
export enum WorkItemModelStatusEnum {
    Running = 'running',
    Binding = 'binding',
    Pending = 'pending',
    Done = 'done',
    NoDataFound = 'no_data_found',
    Error = 'error'
}

